export const RELATED_CONCEPTS_CHANGE = "RELATED_CONCEPTS_CHANGE";
export const FETCH_POST = "FETCH_POST";
export const NEW_POST = "NEW_POST";
export const FETCH_KEYWORD = "FETCH_KEYWORD";
export const FETCH_KEYWORD_WITH_FILTER = "FETCH_KEYWORD_WITH_FILTER";
export const ALL_RESULT_COUNTRY = "ALL_RESULT_COUNTRY";
export const CLINICAL_TRIAL_KEYWORD = "CLINICAL_TRIAL_KEYWORD";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGING_IN = "LOGING_IN_IN";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";
export const SIGNING_IN = "SIGNING_IN";
export const AUTH_TOKEN = "AUTH_TOKEN";
export const TOKEN_FAILURE = "TOKEN_FAILURE";
export const FETCH_KEYWORD_NON_USER = "FETCH_KEYWORD_NON_USER";
export const CLINICAL_TRIAL_FILTER = "CLINICAL_TRIAL_FILTER";
export const COLLABORATOR_CHART = "COLLABORATOR_CHART";
export const USER_SEARCHES = "USER_SEARCHES";
export const SAVED_AUTHORS = "SAVED_AUTHORS";
export const FETCH_EXPERT = "FETCH_EXPERT";
export const EXPERT_WITH_FILTER = "EXPERT_WITH_FILTER";
export const EXPERT_COUNTRY = "EXPERT_COUNTRY";
export const EXPERT_USER_SEARCHES = "EXPERT_USER_SEARCHES";
export const EXPERT_SAVED_AUTHORS = "EXPERT_SAVED_AUTHORS";
export const GEOGRAPHY_COUNTRY_CHANGE = "GEOGRAPHY_COUNTRY_CHANGE";
export const FETCH_GEOGRAPHY = "FETCH_GEOGRAPHY";
export const GEOGRAPHY_USER_SEARCHES = "GEOGRAPHY_USER_SEARCHES";
export const GEOGRAPHY_SAVED_AUTHORS = "GEOGRAPHY_SAVED_AUTHORS";
export const GLOBAL_SAVED_AUTHORS_CHANGE = "GLOBAL_SAVED_AUTHORS_CHANGE";
export const GLOBAL_USER_SEARCHES_CHANGE = "GLOBAL_USER_SEARCHES_CHANGE";
export const KEYWORD_COLLABORATION_CHART = "KEYWORD_COLLABORATION_CHART";
export const GLOBAL_USER_FEATURE_CHANGE = "GLOBAL_USER_FEATURE_CHANGE";
export const GLOBAL_MODULE_ID_CHANGE = "GLOBAL_MODULE_ID_CHANGE";
export const GLOBAL_MODULE_OBJECT_CHANGE = "GLOBAL_MODULE_OBJECT_CHANGE";
export const GLOBAL_MODULES_LIST_CHANGE = "GLOBAL_MODULES_LIST_CHANGE";
export const REMOVE_GLOBAL_TOKEN = "REMOVE_GLOBAL_TOKEN";

// for resetting redux app state
export const RESET_REDUX_APP_STATE = "RESET_REDUX_APP_STATE";

/**
 * NEW TYPES
 */
export const SEARCH_KEYWORD = "SEARCH_KEYWORD";
export const SEARCH_LOADING = "SEARCH_LOADING";
export const CLICK_TAB = "CLICK_TAB";
export const CLICK_USER_PROFILE = "CLICK_USER_PROFILE"; //usr profile
export const SEARCH_KEYWORD_WITH_YEAR = "SEARCH_KEYWORD_WITH_YEAR";
export const SEARCH_KEYWORD_CLINICAL_TRIAL = "SEARCH_KEYWORD_CLINICAL_TRIAL";
export const SEARCH_KEYWORD_AUTHOR = "SEARCH_KEYWORD_AUTHOR";
export const SEARCH_KEYWORD_COUNTRY_CHANGE = "SEARCH_KEYWORD_COUNTRY_CHANGE";
export const UK_LOCATION_RESULT = "UK_LOCATION_RESULT";
export const UK_LOCATION_FILTER = "UK_LOCATION_FILTER";
export const UK_SPECIALITY_FILTER = "UK_SPECIALITY_FILTER";
export const UK_AUTHOR_LIST = "UK_AUTHOR_LIST";
export const UK_TRUST_SELCET = "UK_TRUST_SELCET";
export const CURRENT_SAVED_AUTHOR_CHANGE = "CURRENT_SAVED_AUTHOR_CHANGE";
export const SEARCH_PROFILES = "SEARCH_PROFILES";
export const PROFILE_COLLABORATOR_CHART = "PROFILE_COLLABORATOR_CHART";
export const PROFILE_SEARCH_CHANGE = "PROFILE_SEARCH_CHANGE";
export const COLLABORATOR_PROFILE_SEARCH_CHANGE =
  "COLLABORATOR_PROFILE_SEARCH_CHANGE";
export const COLLABORATOR_PROFILE_SELECT = "COLLABORATOR_PROFILE_SELECT";
export const COLLABORATOR_SEARCH_PROFILES = "COLLABORATOR_SEARCH_PROFILES";
export const CHANGE_COLLABS_LABEL = "CHANGE_COLLABS_LABEL";
export const SEARCH_AFFILIATIONS = "SEARCH_AFFILIATIONS";
export const SEARCH_AFFILIATIONS_INFO = "SEARCH_AFFILIATIONS_INFO";
export const SEARCH_EXPERTS_AFFILIATION = "SEARCH_EXPERTS_AFFILIATION";
export const AFFILIATION_SEARCH_CHANGE = "AFFILIATION_SEARCH_CHANGE";
export const TERM_SEARCH_CHANGE = "TERM_SEARCH_CHANGE";

export const EXPERT_ARRAY_UPDATE = "EXPERT_ARRAY_UPDATE";

// NEW

//RELATED CORPORATE LINKS
export const RELATED_CORPORATE_LINKS_CHANGE = "RELATED_CORPORATE_LINKS_CHANGE";

//EXPERTS
export const REQUEST_EXPERTS = "REQUEST_EXPERTS";
export const RESPONSE_EXPERTS = "RESPONSE_EXPERTS";
export const FAILURE_EXPERTS = "FAILURE_EXPERTS";
export const EXPERT_SUMMARY_TEXT_CHANGE = "EXPERT_SUMMARY_TEXT_CHANGE";
export const RELATED_TERMS_CHANGE = "RELATED_TERMS_CHANGE";
export const REQUEST_EXPERTS_WITH_FILTER = "REQUEST_EXPERTS_WITH_FILTER";
export const RESPONSE_EXPERTS_WITH_FILTER = "RESPONSE_EXPERTS_WITH_FILTER";
export const SORT_EXPERTS = "SORT_EXPERTS";
export const MULTI_SEARCH_CHANGE = "MULTI_SEARCH_CHANGE";
export const MULTI_SEARCH_KEYWORDS_CHANGE = "MULTI_SEARCH_KEYWORDS_CHANGE";

//TWEETS
export const TWEETS_CHANGE = "TWEETS_CHANGE";

//HANDLE EXPERT SEARCH
export const INCREMENT = "INCREMENT";
export const SET_ZERO = "SET_ZERO";
export const SET_ONE = "SET_ONE";

//HANDLE COLLAB AUTOMATED SEARCH
export const SET_ZERO_COLLAB = "SET_ZERO_COLLAB";
export const INCREMENT_COLLAB = "INCREMENT_COLLAB";

//LOCATIONS
export const REQUEST_LOCATION = "REQUEST_LOCATION";
export const RESPONSE_LOCATION = "RESPONSE_LOCATION";
export const FAILURE_LOCATION = "FAILURE_LOCATION";
export const LOCATION_UPDATE = "LOCATION_UPDATE";

//LOCATION_TABLE
export const REQUEST_LOCATION_TABLE = "REQUEST_LOCATION_TABLE";
export const RESPONSE_LOCATION_TABLE = "RESPONSE_LOCATION_TABLE";
export const FAILURE_LOCATION_TABLE = "FAILURE_LOCATION_TABLE";

//PEER REVIEW
export const REQUEST_PEER_REVIEW = "REQUEST_PEER_REVIEW";
export const RESPONSE_PEER_REVIEW = "RESPONSE_PEER_REVIEW";
export const FAILURE_PEER_REVIEW = "FAILURE_PEER_REVIEW";
export const PEER_REVIEWER_RESULT_FILTER = "PEER_REVIEWER_RESULT_FILTER";

export const SET_EMPTY_KEYWORDS = "SET_EMPTY_KEYWORDS";
export const SET_UPDATE_KEYWORDS = "SET_UPDATE_KEYWORDS";
export const SET_UPDATE_SELECTED_KEYWORDS = "SET_UPDATE_SELECTED_KEYWORDS";

//ORGANISATIONS
export const REQUEST_ORGANISATIONS = "REQUEST_ORGANISATIONS";
export const RESPONSE_ORGANISATIONS = "RESPONSE_ORGANISATIONS";
export const FAILURE_ORGANISATIONS = "FAILURE_ORGANISATIONS";
//SEARCH BAR
export const REQUEST_SUGGESTION = "REQUEST_SUGGESTION";
export const RESPONSE_SUGGESTION = "RESPONSE_SUGGESTION";
export const FAILURE_SUGGESTION = "FAILURE_SUGGESTION";
export const REMOVE_SUGGESTION = "REMOVE_SUGGESTION";

//USER SEARCHES
export const REQUEST_USER_SEARCHES = "REQUEST_USER_SEARCHES";
export const RESPONSE_USER_SEARCHES = "RESPONSE_USER_SEARCHES";
export const FAILURE_USER_SEARCHES = "FAILURE_USER_SEARCHES";

//GET EXPERT ALL ACTION COMBINED
export const REQUEST_GET_EXPERTS = "REQUEST_GET_EXPERTS";
export const RESPONSE_GET_EXPERTS = "RESPONSE_GET_EXPERTS";
export const FAILURE_GET_EXPERTS = "FAILURE_GET_EXPERTS";

//CLINICAL TRIALS
export const REQUEST_TRIALS = "REQUEST_TRIALS";
export const RESPONSE_TRIALS = "RESPONSE_TRIALS";
export const FAILURE_TRIALS = "FAILURE_TRIALS";
export const CHANGE_CLINICAL_TRIAL_FILTER = "CHANGE_CLINICAL_TRIAL_FILTER";
export const CLEAR_CLINICAL_TRIAL_FILTER = "CLEAR_CLINICAL_TRIAL_FILTER";
export const SORT_CLINICAL_TRIAL = "SORT_CLINICAL_TRIAL";
export const CLINICAL_TRIAL_MORE_REQUEST = "CLINICAL_TRIAL_MORE_REQUEST";
export const CLINICAL_TRIAL_MORE_FAILURE = "CLINICAL_TRIAL_MORE_FAILURE";
export const CLINICAL_TRIAL_MORE_RESPONSE = "CLINICAL_TRIAL_MORE_RESPONSE";
export const REQUEST_TRIALS_WITH_FILTER = "REQUEST_TRIALS_WITH_FILTER";

//EXPERT BIO
export const EXPERT_CREDENTIALS_RESPONSE = "EXPERT_CREDENTIALS_RESPONSE";
export const EXPERT_CREDENTIALS_FAILURE = "EXPERT_CREDENTIALS_FAILURE";
export const EXPERT_ARTICLES_RESPONSE = "EXPERT_ARTICLES_RESPONSE";
export const EXPERT_ARTICLES_FAILURE = "EXPERT_ARTICLES_FAILURE";
export const EXPERT_HISTOGRAM_RESPONSE = "EXPERT_HISTOGRAM_RESPONSE";
export const EXPERT_HISTOGRAM_FAILURE = "EXPERT_HISTOGRAM_FAILURE";
export const EXPERT_EXTERNAL_LINK_CHANGE = "EXPERT_EXTERNAL_LINK_CHANGE";
export const EXPERT_EXTERNAL_LINK_CHANGE_FAILURE =
  "EXPERT_EXTERNAL_LINK_CHANGE_FAILURE";
export const EXPERT_TRIALS_RESPONSE = "EXPERT_TRIALS_RESPONSE";
export const EXPERT_TRIALS_FAILURE = "EXPERT_TRIALS_FAILURE";
export const EXPERT_BIO_COLLABS_RESPONSE = "EXPERT_COLLABS_RESPONSE";
export const EXPERT_BIO_COLLABS_FAILURE = "EXPERT_COLLABS_FAILURE";
export const EXPERT_ARTICLES_MORE_REQUEST = "EXPERT_ARTICLES_MORE_REQUEST";
export const EXPERT_ARTICLES_MORE_FAILURE = "EXPERT_ARTICLES_MORE_FAILURE";
export const EXPERT_ARTICLES_MORE_RESPONSE = "EXPERT_ARTICLES_MORE_RESPONSE";
export const EXPERT_CREDENTIALS_REQUEST = "EXPERT_CREDENTIALS_REQUEST";
export const CLEAR_EXPERT_BIO_RESULTS = "CLEAR_EXPERT_BIO_RESULTS";
export const EXPERT_GRANTS_RESPONSE = "EXPERT_GRANTS_RESPONSE";
export const EXPERT_GRANTS_FAILURE = "EXPERT_GRANTS_FAILURE";
export const EXPERT_GRANTS_MORE_REQUEST = "EXPERT_GRANTS_MORE_REQUEST";
export const EXPERT_GRANTS_MORE_FAILURE = "EXPERT_GRANTS_MORE_FAILURE";
export const EXPERT_GRANTS_MORE_RESPONSE = "EXPERT_GRANTS_MORE_RESPONSE";
export const EXPERT_GRANTS_UPDATE = "EXPERT_GRANTS_UPDATE";
export const EXPERT_MSA_ARTICLES_RESPONSE = "EXPERT_MSA_ARTICLES_RESPONSE";
export const EXPERT_MSA_ARTICLES_FAILURE = "EXPERT_MSA_ARTICLES_FAILURE";
export const EXPERT_MSA_ARTICLES_MORE_REQUEST =
  "EXPERT_MSA_ARTICLES_MORE_REQUEST";
export const EXPERT_MSA_ARTICLES_MORE_FAILURE =
  "EXPERT_MSA_ARTICLES_MORE_FAILURE";
export const EXPERT_MSA_ARTICLES_MORE_RESPONSE =
  "EXPERT_MSA_ARTICLES_MORE_RESPONSE";

export const EXPERT_OPENPAYMENT_RESPONSE = "EXPERT_OPENPAYMENT_RESPONSE";
export const EXPERT_OPENPAYMENT_FAILURE = "EXPERT_OPENPAYMENT_FAILURE";
export const EXPERT_OPENPAYMENT_MORE_REQUEST =
  "EXPERT_OPENPAYMENT_MORE_REQUEST";
export const EXPERT_OPENPAYMENT_MORE_FAILURE =
  "EXPERT_OPENPAYMENT_MORE_FAILURE";
export const EXPERT_OPENPAYMENT_MORE_RESPONSE =
  "EXPERT_OPENPAYMENT_MORE_RESPONSE";

//EXPERT COLLAB
export const REQUEST_BIO_COLLAB = "REQUEST_BIO_COLLAB";
export const RESPONSE_BIO_COLLAB = "RESPONSE_BIO_COLLAB";
export const FAILURE_BIO_COLLAB = "FAILURE_BIO_COLLAB";

//EXPERT PREV AFF
export const REQUEST_BIO_AFF = "REQUEST_BIO_AFF";
export const RESPONSE_BIO_AFF = "RESPONSE_BIO_AFF";
export const FAILURE_BIO_AFF = "FAILURE_BIO_AFF";

//TOPIC
export const TOPIC_ARTICLES_RESPONSE = "TOPIC_ARTICLES_RESPONSE";
export const TOPIC_ARTICLES_FAILURE = "TOPIC_ARTICLES_FAILURE";
export const TOPIC_HISTOGRAM_RESPONSE = "TOPIC_HISTOGRAM_RESPONSE";
export const TOPIC_HISTOGRAM_FAILURE = "TOPIC_HISTOGRAM_FAILURE";
export const TOPIC_ARTICLES_REQUEST = "TOPIC_ARTICLES_REQUEST";
export const TOPIC_ARTICLES_MORE_REQUEST = "TOPIC_ARTICLES_MORE_REQUEST";
export const TOPIC_ARTICLES_MORE_FAILURE = "TOPIC_ARTICLES_MORE_FAILURE";
export const TOPIC_ARTICLES_MORE_RESPONSE = "TOPIC_ARTICLES_MORE_RESPONSE";

//COLLABORATOR NETWORK
export const REQUEST_COLLABORATOR_NETWORK = "REQUEST_COLLABORATOR_NETWORK";
export const RESPONSE_COLLABORATOR_NETWORK = "RESPONSE_COLLABORATOR_NETWORK";
export const FAILURE_COLLABORATOR_NETWORK = "FAILURE_COLLABORATOR_NETWORK";
export const REQUEST_EXPERT_COLLABORATORS = "REQUEST_EXPERT_COLLABORATORS";
export const RESPONSE_EXPERT_COLLABORATORS = "RESPONSE_EXPERT_COLLABORATORS";
export const FAILURE_EXPERT_COLLABORATORS = "RESPONSE_EXPERT_COLLABORATORS";
export const RESPONSE_MAIN_NETWORK_SEARCH_TERMS = "RESPONSE_MAIN_NETWORK_SEARCH_TERMS";

//COLLABORATOR NETWORK PROFILE
export const REQUEST_COLLABORATOR_NETWORK_PROFILE =
  "REQUEST_COLLABORATOR_NETWORK_PROFILE";
export const RESPONSE_COLLABORATOR_NETWORK_PROFILE =
  "RESPONSE_COLLABORATOR_NETWORK_PROFILE";
export const FAILURE_COLLABORATOR_NETWORK_PROFILE =
  "FAILURE_COLLABORATOR_NETWORK_PROFILE";

//COLLABORATOR NETWORK PROFILE GET EXPERTS
export const REQUEST_EXPERT_COLLABORATORS_PROFILE =
  "REQUEST_EXPERT_COLLABORATORS_PROFILE";
export const RESPONSE_EXPERT_COLLABORATORS_PROFILE =
  "RESPONSE_EXPERT_COLLABORATORS_PROFILE";
export const FAILURE_EXPERT_COLLABORATORS_PROFILE =
  "FAILURE_EXPERT_COLLABORATORS_PROFILE";

//KEYWORD NETWORK
export const REQUEST_KEYWORD_NETWORK = "REQUEST_KEYWORD_NETWORK";
export const RESPONSE_KEYWORD_NETWORK = "RESPONSE_KEYWORD_NETWORK";
export const FAILURE_KEYWORD_NETWORK = " FAILURE_KEYWORD_NETWORK";

//PROFILE SEARCH
export const REQUEST_PROFILE_EXPERTS = "REQUEST_PROFILE_EXPERTS";
export const RESPONSE_PROFILE_EXPERTS = "RESPONSE_PROFILE_EXPERTS";
export const FAILURE_PROFILE_EXPERTS = "FAILURE_PROFILE_EXPERTS";

//SENIORITY PROFILE SEARCH
export const REQUEST_SENIORITY_EXPERTS = "REQUEST_SENIORITY_EXPERTS";
export const RESPONSE_SENIORITY_EXPERTS = "RESPONSE_SENIORITY_EXPERTS";
export const FAILURE_SENIORITY_EXPERTS = "FAILURE_SENIORITY_EXPERTS";

//AFFILIATION BASED PROFILE SEARCH
export const REQUEST_AFFILIATION_PROFILE_EXPERTS =
  "REQUEST_AFFILIATION_PROFILE_EXPERTS";
export const RESPONSE_AFFILIATION_PROFILE_EXPERTS =
  "RESPONSE_AFFILIATION_PROFILE_EXPERTS";
export const FAILURE_AFFILIATION_PROFILE_EXPERTS =
  "FAILURE_AFFILIATION_PROFILE_EXPERTS";
export const EXPERT_PROFILE_PAGE_REQUEST = "EXPERT_PROFILE_PAGE_REQUEST";

//USER
//REGISTER
export const USER_REGISTER_EMAIL_CHANGE = "USER_REGISTER_EMAIL_CHANGE";
export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_RESPONSE = "USER_REGISTER_RESPONSE";
export const USER_REGISTER_FAILURE = "USER_REGISTER_FAILURE";
export const USER_REGISTER_RESET_FIELDS = "USER_REGISTER_RESET_FIELDS";
export const CHANGE_REGISTER_INPUTS = "CHANGE_REGISTER_INPUTS";
export const CHANGE_REGISTER_ERR_MSG = "CHANGE_REGISTER_ERR_MSG";

//LOGIN
export const USER_LOGIN_EMAIL_CHANGE = "USER_LOGIN_EMAIL_CHANGE";
export const USER_LOGIN_PASSWORD_CHANGE = "USER_LOGIN_PASSWORD_CHANGE";
export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_RESPONSE = "USER_LOGIN_RESPONSE";
export const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE";
export const USER_LOGIN_RESET_FIELDS = "USER_LOGIN_RESET_FIELDS";

//GLOBAL
export const GLOBAL_KEYWORD_CHANGE = "GLOBAL_KEYWORD_CHANGE";
export const GLOBAL_USER_TOKEN_CHANGE = "GLOBAL_USER_TOKEN_CHANGE";

//EXPERT MULTISEARCH
export const EXPERT_MULTI_SEARCH_REQUEST = "EXPERT_MULTI_SEARCH_REQUEST";
export const EXPERT_MULTI_SEARCH_RESPONSE = "EXPERT_MULTI_SEARCH_RESPONSE";
export const EXPERT_MULTI_SEARCH_FAILURE = "EXPERT_MULTI_SEARCH_FAILURE";

//MULTI SEARH ACTIONS
export const MULTI_RELTED_TERMS_CHANGE = "MULTI_RELTED_TERMS_CHANGE";
export const MULTI_CORPORATE_CHANGE = "MULTI_CORPORATE_CHANGE";
export const EXPERT_MULTI_KEYWORD_CHANGE = "EXPERT_MULTI_KEYWORD_CHANGE";
export const MULTI_SUMMARY_CHANGE = "MULTI_SUMMARY_CHANGE";

//INSTITUTES
export const REQUEST_INSTITUTE = "REQUEST_INSTITUTE";
export const RESPONSE_INSTITUTE = "RESPONSE_INSTITUTE";
export const FAILURE_INSTITUTE = "FAILURE_INSTITUTE";
export const REQUEST_INSTITUTE_WITH_FILTER = "REQUEST_INSTITUTE_WITH_FILTER";

//ABSTRACT_FROM_FILE
export const SET_ABSTRACT_FROM_FILE = "SET_ABSTRACT_FROM_FILE";

//AFF CREDENTIALS
export const AFF_CREDENTIALS_REQUEST = "AFF_CREDENTIALS_REQUEST";
export const AFF_CREDENTIALS_RESPONSE = "AFF_CREDENTIALS_RESPONSE";
export const AFF_CREDENTIALS_FAILURE = "AFF_CREDENTIALS_FAILURE";

//AFF ARTICLES
export const AFF_ARTICLES_RESPONSE = "AFF_ARTICLES_RESPONSE";
export const AFF_ARTICLES_FAILURE = "AFF_ARTICLES_FAILURE";
export const AFF_ARTICLES_MORE_REQUEST = "AFF_ARTICLES_MORE_REQUEST";
export const AFF_ARTICLES_MORE_FAILURE = "AFF_ARTICLES_MORE_FAILURE";
export const AFF_ARTICLES_MORE_RESPONSE = "AFF_ARTICLES_MORE_RESPONSE";

//AFF EXPERTS
export const AFF_EXPERTS_RESPONSE = "AFF_EXPERTS_RESPONSE";
export const AFF_EXPERTS_FAILURE = "AFF_EXPERTS_FAILURE";

// SENIORITY SCHEMA
export const SENIOR_SCHEMA_REQUEST = "SENIOR_SCHEMA_REQUEST";
export const SENIOR_SCHEMA_RESPONSE = "SENIOR_SCHEMA_RESPONSE";
export const SENIOR_SCHEMA_FAILURE = "SENIOR_SCHEMA_FAILURE";

export const GET_AFF_TRIALS_REQUEST = "GET_AFF_TRIALS_REQUEST";
export const GET_AFF_TRIALS_RESPONSE = "GET_AFF_TRIALS_RESPONSE";
export const GET_AFF_TRIALS_FAILURE = "GET_AFF_TRIALS_FAILURE";

export const GET_SOCMED_CITATION_REQUEST = "GET_SOCMED_CITATION_REQUEST";
export const GET_SOCMED_CITATION_RESPONSE = "GET_SOCMED_CITATION_RESPONSE";
export const GET_SOCMED_CITATION_FAILURE = "GET_SOCMED_CITATION_FAILURE";

export const GET_SOCIAL_CITATION_REQUEST = "GET_SOCIAL_CITATION_REQUEST";
export const GET_SOCIAL_CITATION_RESPONSE = "GET_SOCIAL_CITATION_RESPONSE";
export const GET_SOCIAL_CITATION_FAILURE = "GET_SOCIAL_CITATION_FAILURE";

export const REQUEST_LOCATION_TRIAL = "REQUEST_LOCATION_TRIAL";
export const RESPONSE_LOCATION_TRIAL = "RESPONSE_LOCATION_TRIAL";
export const FAILURE_LOCATION_TRIAL = "FAILURE_LOCATION_TRIAL";

//GRANTS
export const REQUEST_KEYWORD_GRANTS = "REQUEST_KEYWORD_GRANTS";
export const RESPONSE_KEYWORD_GRANTS = "RESPONSE_KEYWORD_GRANTS";
export const FAILURE_KEYWORD_GRANTS = "FAILURE_KEYWORD_GRANTS";
export const REQUEST_KEYWORD_GRANTS_WITH_FILTER =
  "REQUEST_KEYWORD_GRANTS_WITH_FILTER";

//TWITTER CONFERENCE
export const REQUEST_KEYWORD_TWITTER_CONF = "REQUEST_KEYWORD_TWITTER_CONF";
export const RESPONSE_KEYWORD_TWITTER_CONF = "RESPONSE_KEYWORD_TWITTER_CONF";
export const FAILURE_KEYWORD_TWITTER_CONF = "FAILURE_KEYWORD_TWITTER_CONF";

//topic article update
export const SORT_ARTICLE_UPDATE = "SORT_ARTICLE_UPDATE";

//Grant sort update
export const GRANT_SORT_UPDATE = "GRANT_SORT_UPDATE";

export const AFF_SORT_UPDATE = "AFF_SORT_UPDATE";

//active sort item experts
export const SORT_VAL_EXPERTS = "SORT_VAL_EXPERTS";

export const LOCATION_SORT_ONE = "LOCATION_SORT_ONE";

export const LOCATION_SORT_TWO = "LOCATION_SORT_TWO";

export const LOCATION_SORT_THREE = "LOCATION_SORT_THREE";

export const COLLAB_CLUSTER_UPDATE = "COLLAB_CLUSTER_UPDATE";

//pagination update activate
export const PAGINATION_EXPERTS_UPDATE = "PAGINATION_EXPERTS_UPDATE";

// mld home
export const REQUEST_MLD_HOME_SEARCH = "REQUEST_MLD_HOME_SEARCH";
export const RESPONSE_MLD_HOME_SEARCH = "RESPONSE_MLD_HOME_SEARCH";
export const FAILURE_MLD_HOME_SEARCH = "FAILURE_MLD_HOME_SEARCH";
export const UPDATE_MLD_HOME_SEARCH_FILTER = "UPDATE_MLD_HOME_SEARCH_FILTER";
export const MLD_HOME_PROFESSIONALS_UPDATE_FILTER = "MLD_HOME_PROFESSIONALS_UPDATE_FILTER";
export const TOGGLE_MLD_HOME_SAVE_MODE = "TOGGLE_MLD_HOME_SAVE_MODE";
export const UPDATE_MLD_HOME_SAVE_LIST_ITEMS = "UPDATE_MLD_HOME_SAVE_LIST_ITEMS";
export const UPDATE_MLD_HOME_SAVE_LIST_TYPE = "UPDATE_MLD_HOME_SAVE_LIST_TYPE";
export const UPDATE_MLD_HOME_COLUMNS = "UPDATE_MLD_HOME_COLUMNS";
export const UPDATE_MLD_HOME_CHECKBOX_FILTERS = "UPDATE_MLD_HOME_CHECKBOX_FILTERS";
export const UPDATE_MLD_HOME_MULTI_SORT = "UPDATE_MLD_HOME_MULTI_SORT";

//mld professionals
export const MLD_PROFESSIONALS_RESPONSE = "MLD_PROFESSIONALS_RESPONSE";
export const MLD_PROFESSIONALS_FAILURE = "MLD_PROFESSIONALS_FAILURE";
export const MLD_PROFESSIONALS_REQUEST = "MLD_PROFESSIONALS_REQUEST";
export const MLD_PROFESSIONALS_UPDATE_FILTER =
  "MLD_PROFESSIONALS_UPDATE_FILTER";
export const REQUEST_SUMMARY_LOCATION_MLD = "REQUEST_SUMMARY_LOCATION_MLD";
export const RESPONSE_SUMMARY_LOCATION_MLD = "RESPONSE_SUMMARY_LOCATION_MLD";
export const FAILURE_SUMMARY_LOCATION_MLD = "FAILURE_SUMMARY_LOCATION_MLD";
export const MLD_PROFESSIONALS_SHORT_UPDATE_FILTER =
  "MLD_PROFESSIONALS_SHORT_UPDATE_FILTER";
export const MLD_NETWORK_FILTER_UPDATE = "MLD_NETWORK_FILTER_UPDATE";
export const MLD_NETWORK_RESULT_STATE_UPDATE = "MLD_NETWORK_RESULT_STATE_UPDATE";

//mld medical bodies
export const REQUEST_MLD_MEDICAL_BODIES = "REQUEST_MLD_MEDICAL_BODIES";
export const RESPONSE_MLD_MEDICAL_BODIES = "RESPONSE_MLD_MEDICAL_BODIES";
export const FAILURE_MLD_MEDICAL_BODIES = "FAILURE_MLD_MEDICAL_BODIES";
export const UPDATE_MLD_RESULTS = "UPDATE_MLD_RESULTS";

//clinical trial site api by id
export const REQUEST_TRIALS_ID = "REQUEST_TRIALS_ID";
export const RESPONSE_TRIALS_ID = "RESPONSE_TRIALS_ID";
export const FAILURE_TRIALS_ID = "FAILURE_TRIALS_ID";

//keyword rank
export const KEYWORD_REQUEST_RESPONSE = "KEYWORD_REQUEST_RESPONSE";
export const KEYWORD_REQUEST_FAILURE = "KEYWORD_REQUEST_FAILURE";
export const KEYWORD_REQUEST_REQUEST = "KEYWORD_REQUEST_REQUEST";

//expert edit links
export const EXPERTS_LINK_EDIT_REQUEST = "EXPERTS_LINK_EDIT_REQUEST";
export const EXPERTS_LINK_EDIT_RESPONSE = "EXPERTS_LINK_EDIT_RESPONSE";
export const EXPERTS_LINK_EDIT_FAILURE = "EXPERTS_LINK_EDIT_FAILURE";
export const UPDATE_EXPERT_BIO_CREDENTIALS = "UPDATE_EXPERT_BIO_CREDENTIALS";

//mld social body
export const MLD_SOCIAL_BODY_REQUEST = "MLD_SOCIAL_BODY_REQUEST";
export const MLD_SOCIAL_BODY_RESPONSE = "MLD_SOCIAL_BODY_RESPONSE";
export const MLD_SOCIAL_BODY_FAILURE = "MLD_SOCIAL_BODY_FAILURE";

//mld conf
export const MLD_SOCIAL_CONF_REQUEST = "MLD_SOCIAL_CONF_REQUEST";
export const MLD_SOCIAL_CONF_RESPONSE = "MLD_SOCIAL_CONF_RESPONSE";
export const MLD_SOCIAL_CONF_FAILURE = "MLD_SOCIAL_CONF_FAILURE";

//mld clinical trials
export const REQUEST_MLD_TRIALS = "REQUEST_MLD_TRIALS";
export const RESPONSE_MLD_TRIALS = "RESPONSE_MLD_TRIALS";
export const FAILURE_MLD_TRIALS = "FAILURE_MLD_TRIALS";
export const SORT_MLD_CLINICAL_TRIAL = "SORT_MLD_CLINICAL_TRIAL";
export const MLD_CLINICAL_TRIAL_MORE_REQUEST =
  "MLD_CLINICAL_TRIAL_MORE_REQUEST";
export const MLD_CLINICAL_TRIAL_MORE_FAILURE =
  "MLD_CLINICAL_TRIAL_MORE_FAILURE";
export const MLD_CLINICAL_TRIAL_MORE_RESPONSE =
  "MLD_CLINICAL_TRIAL_MORE_RESPONSE";
export const CLEAR_MLD_CLINICAL_TRIAL_FILTER =
  "CLEAR_MLD_CLINICAL_TRIAL_FILTER";
export const CHANGE_MLD_CLINICAL_TRIAL_FILTER =
  "CHANGE_MLD_CLINICAL_TRIAL_FILTER";
export const REQUEST_MLD_TRIALS_WITH_FILTER = "REQUEST_MLD_TRIALS_WITH_FILTER";

//mld professionals select option
export const MLD_PROFESSIONALS_SELECT = "MLD_PROFESSIONALS_SELECT";
export const MLD_PROFESSIONALS_REMOVE_SELECT =
  "MLD_PROFESSIONALS_REMOVE_SELECT";
export const MLD_PROFESSIONALS_SHORT_LIST_TOGGLE =
  "MLD_PROFESSIONALS_SHORT_LIST_TOGGLE";
export const MLD_PROFESSIONALS_SHORT_LIST_SAVE_REQUEST =
  "MLD_PROFESSIONALS_SHORT_LIST_SAVE_REQUEST";
export const MLD_PROFESSIONALS_SHORT_LIST_SAVE_RESPONSE =
  "MLD_PROFESSIONALS_SHORT_LIST_SAVE_RESPONSE";

//mld professionals short listed experts
export const MLD_SHORT_LIST_PROFESSIONALS_RESPONSE =
  "MLD_SHORT_LIST_PROFESSIONALS_RESPONSE";
export const MLD_SHORT_LIST_PROFESSIONALS_FAILURE =
  "MLD_SHORT_LIST_PROFESSIONALS_FAILURE";
export const MLD_SHORT_LIST_PROFESSIONALS_REQUEST =
  "MLD_SHORT_LIST_PROFESSIONALS_REQUEST";
export const MLD_PROFESSIONALS_UPDATE = "MLD_PROFESSIONALS_UPDATE";

//mld professionals slect final experts
export const MLD_PROFESSIONALS_SELECT_SHORT_LIST =
  "MLD_PROFESSIONALS_SELECT_SHORT_LIST";
export const MLD_PROFESSIONALS_REMOVE_SELECT_SHORT_LIST =
  "MLD_PROFESSIONALS_REMOVE_SELECT_SHORT_LIST";
export const MLD_PROFESSIONALS_SELECT_LIST_TOGGLE =
  "MLD_PROFESSIONALS_SELECT_LIST_TOGGLE";
export const MLD_PROFESSIONALS_SELECT_LIST_SAVE_REQUEST =
  "MLD_PROFESSIONALS_SELECT_LIST_SAVE_REQUEST";
export const MLD_SHORT_LIST_PROFESSIONALS_UPDATE =
  "MLD_SHORT_LIST_PROFESSIONALS_UPDATE";
export const MLD_PROFESSIONALS_SELECT_LIST_SAVE_RESPONSE =
  "MLD_PROFESSIONALS_SELECT_LIST_SAVE_RESPONSE";
export const MLD_PROFESSIONALS_SHORT_LIST_REMOVE_RESPONSE =
  "MLD_PROFESSIONALS_SHORT_LIST_REMOVE_RESPONSE";

//mld selected list removed
export const MLD_SHORT_LIST_REMOVED_PROFESSIONALS_RESPONSE =
  "MLD_SHORT_LIST_REMOVED_PROFESSIONALS_RESPONSE";
export const MLD_SHORT_LIST_REMOVED_PROFESSIONALS_FAILURE =
  "MLD_SHORT_LIST_REMOVED_PROFESSIONALS_FAILURE";
export const MLD_SHORT_LIST_REMOVED_PROFESSIONALS_REQUEST =
  "MLD_SHORT_LIST_REMOVED_PROFESSIONALS_REQUEST";
export const MLD_PROFESSIONALS_SHORT_REMOVED_UPDATE_FILTER =
  "MLD_PROFESSIONALS_SHORT_REMOVED_UPDATE_FILTER";

//mld selected list
export const MLD_SELECTED_LIST_PROFESSIONALS_RESPONSE =
  "MLD_SELECTED_LIST_PROFESSIONALS_RESPONSE";
export const MLD_SELECTED_LIST_PROFESSIONALS_FAILURE =
  "MLD_SELECTED_LIST_PROFESSIONALS_FAILURE";
export const MLD_SELECTED_LIST_PROFESSIONALS_REQUEST =
  "MLD_SELECTED_LIST_PROFESSIONALS_REQUEST";
export const MLD_SELECTED_LIST_PROFESSIONALS_UPDATE =
  "MLD_SELECTED_LIST_PROFESSIONALS_UPDATE";
export const MLD_PROFESSIONALS_SELECT_LIST_REMOVE_RESPONSE =
  "MLD_PROFESSIONALS_SELECT_LIST_REMOVE_RESPONSE";
export const MLD_PROFESSIONALS_SELECT_UPDATE_FILTER =
  "MLD_PROFESSIONALS_SELECT_UPDATE_FILTER";

//mld affiiations list
export const MLD_AFFILIATIONS_RESPONSE = "MLD_AFFILIATIONS_RESPONSE";
export const MLD_AFFILIATIONS_FAILURE = "MLD_AFFILIATIONS_FAILURE";
export const MLD_AFFILIATIONS_REQUEST = "MLD_AFFILIATIONS_REQUEST";
export const MLD_AFFILIATIONS_UPDATE = "MLD_AFFILIATIONS_UPDATE";

//mld location types
export const REQUEST_LOCATION_MLD = "REQUEST_LOCATION_MLD";
export const RESPONSE_LOCATION_MLD = "RESPONSE_LOCATION_MLD";
export const FAILURE_LOCATION_MLD = "FAILURE_LOCATION_MLD";
export const LOCATION_UPDATE_MLD = "LOCATION_UPDATE_MLD";

//mld location table
export const REQUEST_LOCATION_TABLE_MLD = "REQUEST_LOCATION_TABLE_MLD";
export const RESPONSE_LOCATION_TABLE_MLD = "RESPONSE_LOCATION_TABLE_MLD";
export const FAILURE_LOCATION_TABLE_MLD = "FAILURE_LOCATION_TABLE_MLD";

//mld network MLD_NETWORK_RESPONSE,
export const MLD_NETWORK_RESPONSE = "MLD_NETWORK_RESPONSE";
export const MLD_NETWORK_FAILURE = "MLD_NETWORK_FAILURE";
export const MLD_NETWORK_REQUEST = "MLD_NETWORK_REQUEST";
export const MLD_NETWORK_SELECT_EXPERTS = "MLD_NETWORK_SELECT_EXPERTS";

//ALD professionals
export const ALD_PROFESSIONALS_RESPONSE = "ALD_PROFESSIONALS_RESPONSE";
export const ALD_PROFESSIONALS_FAILURE = "ALD_PROFESSIONALS_FAILURE";
export const ALD_PROFESSIONALS_REQUEST = "ALD_PROFESSIONALS_REQUEST";
export const ALD_PROFESSIONALS_UPDATE_FILTER =
  "ALD_PROFESSIONALS_UPDATE_FILTER";
export const REQUEST_SUMMARY_LOCATION_ALD = "REQUEST_SUMMARY_LOCATION_ALD";
export const RESPONSE_SUMMARY_LOCATION_ALD = "RESPONSE_SUMMARY_LOCATION_ALD";
export const FAILURE_SUMMARY_LOCATION_ALD = "FAILURE_SUMMARY_LOCATION_ALD";
export const ALD_PROFESSIONALS_SHORT_UPDATE_FILTER =
  "ALD_PROFESSIONALS_SHORT_UPDATE_FILTER";
export const ALD_NETWORK_FILTER_UPDATE = "ALD_NETWORK_FILTER_UPDATE";

//ALD medical bodies
export const REQUEST_ALD_MEDICAL_BODIES = "REQUEST_ALD_MEDICAL_BODIES";
export const RESPONSE_ALD_MEDICAL_BODIES = "RESPONSE_ALD_MEDICAL_BODIES";
export const FAILURE_ALD_MEDICAL_BODIES = "FAILURE_ALD_MEDICAL_BODIES";
export const UPDATE_ALD_RESULTS = "UPDATE_ALD_RESULTS";
//ALD social body
export const ALD_SOCIAL_BODY_REQUEST = "ALD_SOCIAL_BODY_REQUEST";
export const ALD_SOCIAL_BODY_RESPONSE = "ALD_SOCIAL_BODY_RESPONSE";
export const ALD_SOCIAL_BODY_FAILURE = "ALD_SOCIAL_BODY_FAILURE";

//ALD conf
export const ALD_SOCIAL_CONF_REQUEST = "ALD_SOCIAL_CONF_REQUEST";
export const ALD_SOCIAL_CONF_RESPONSE = "ALD_SOCIAL_CONF_RESPONSE";
export const ALD_SOCIAL_CONF_FAILURE = "ALD_SOCIAL_CONF_FAILURE";

//ALD clinical trials
export const REQUEST_ALD_TRIALS = "REQUEST_ALD_TRIALS";
export const RESPONSE_ALD_TRIALS = "RESPONSE_ALD_TRIALS";
export const FAILURE_ALD_TRIALS = "FAILURE_ALD_TRIALS";
export const SORT_ALD_CLINICAL_TRIAL = "SORT_ALD_CLINICAL_TRIAL";
export const ALD_CLINICAL_TRIAL_MORE_REQUEST =
  "ALD_CLINICAL_TRIAL_MORE_REQUEST";
export const ALD_CLINICAL_TRIAL_MORE_FAILURE =
  "ALD_CLINICAL_TRIAL_MORE_FAILURE";
export const ALD_CLINICAL_TRIAL_MORE_RESPONSE =
  "ALD_CLINICAL_TRIAL_MORE_RESPONSE";
export const CLEAR_ALD_CLINICAL_TRIAL_FILTER =
  "CLEAR_ALD_CLINICAL_TRIAL_FILTER";
export const CHANGE_ALD_CLINICAL_TRIAL_FILTER =
  "CHANGE_ALD_CLINICAL_TRIAL_FILTER";
export const REQUEST_ALD_TRIALS_WITH_FILTER = "REQUEST_ALD_TRIALS_WITH_FILTER";

//ALD professionals select option
export const ALD_PROFESSIONALS_SELECT = "ALD_PROFESSIONALS_SELECT";
export const ALD_PROFESSIONALS_REMOVE_SELECT =
  "ALD_PROFESSIONALS_REMOVE_SELECT";
export const ALD_PROFESSIONALS_SHORT_LIST_TOGGLE =
  "ALD_PROFESSIONALS_SHORT_LIST_TOGGLE";
export const ALD_PROFESSIONALS_SHORT_LIST_SAVE_REQUEST =
  "ALD_PROFESSIONALS_SHORT_LIST_SAVE_REQUEST";
export const ALD_PROFESSIONALS_SHORT_LIST_SAVE_RESPONSE =
  "ALD_PROFESSIONALS_SHORT_LIST_SAVE_RESPONSE";

//ALD professionals short listed experts
export const ALD_SHORT_LIST_PROFESSIONALS_RESPONSE =
  "ALD_SHORT_LIST_PROFESSIONALS_RESPONSE";
export const ALD_SHORT_LIST_PROFESSIONALS_FAILURE =
  "ALD_SHORT_LIST_PROFESSIONALS_FAILURE";
export const ALD_SHORT_LIST_PROFESSIONALS_REQUEST =
  "ALD_SHORT_LIST_PROFESSIONALS_REQUEST";
export const ALD_PROFESSIONALS_UPDATE = "ALD_PROFESSIONALS_UPDATE";

//ALD professionals slect final experts
export const ALD_PROFESSIONALS_SELECT_SHORT_LIST =
  "ALD_PROFESSIONALS_SELECT_SHORT_LIST";
export const ALD_PROFESSIONALS_REMOVE_SELECT_SHORT_LIST =
  "ALD_PROFESSIONALS_REMOVE_SELECT_SHORT_LIST";
export const ALD_PROFESSIONALS_SELECT_LIST_TOGGLE =
  "ALD_PROFESSIONALS_SELECT_LIST_TOGGLE";
export const ALD_PROFESSIONALS_SELECT_LIST_SAVE_REQUEST =
  "ALD_PROFESSIONALS_SELECT_LIST_SAVE_REQUEST";
export const ALD_SHORT_LIST_PROFESSIONALS_UPDATE =
  "ALD_SHORT_LIST_PROFESSIONALS_UPDATE";
export const ALD_PROFESSIONALS_SELECT_LIST_SAVE_RESPONSE =
  "ALD_PROFESSIONALS_SELECT_LIST_SAVE_RESPONSE";
export const ALD_PROFESSIONALS_SHORT_LIST_REMOVE_RESPONSE =
  "ALD_PROFESSIONALS_SHORT_LIST_REMOVE_RESPONSE";

//ALD selected list removed
export const ALD_SHORT_LIST_REMOVED_PROFESSIONALS_RESPONSE =
  "ALD_SHORT_LIST_REMOVED_PROFESSIONALS_RESPONSE";
export const ALD_SHORT_LIST_REMOVED_PROFESSIONALS_FAILURE =
  "ALD_SHORT_LIST_REMOVED_PROFESSIONALS_FAILURE";
export const ALD_SHORT_LIST_REMOVED_PROFESSIONALS_REQUEST =
  "ALD_SHORT_LIST_REMOVED_PROFESSIONALS_REQUEST";
export const ALD_PROFESSIONALS_SHORT_REMOVED_UPDATE_FILTER =
  "ALD_PROFESSIONALS_SHORT_REMOVED_UPDATE_FILTER";

//ALD selected list
export const ALD_SELECTED_LIST_PROFESSIONALS_RESPONSE =
  "ALD_SELECTED_LIST_PROFESSIONALS_RESPONSE";
export const ALD_SELECTED_LIST_PROFESSIONALS_FAILURE =
  "ALD_SELECTED_LIST_PROFESSIONALS_FAILURE";
export const ALD_SELECTED_LIST_PROFESSIONALS_REQUEST =
  "ALD_SELECTED_LIST_PROFESSIONALS_REQUEST";
export const ALD_SELECTED_LIST_PROFESSIONALS_UPDATE =
  "ALD_SELECTED_LIST_PROFESSIONALS_UPDATE";
export const ALD_PROFESSIONALS_SELECT_LIST_REMOVE_RESPONSE =
  "ALD_PROFESSIONALS_SELECT_LIST_REMOVE_RESPONSE";
export const ALD_PROFESSIONALS_SELECT_UPDATE_FILTER =
  "ALD_PROFESSIONALS_SELECT_UPDATE_FILTER";

//ALD affiiations list
export const ALD_AFFILIATIONS_RESPONSE = "ALD_AFFILIATIONS_RESPONSE";
export const ALD_AFFILIATIONS_FAILURE = "ALD_AFFILIATIONS_FAILURE";
export const ALD_AFFILIATIONS_REQUEST = "ALD_AFFILIATIONS_REQUEST";
export const ALD_AFFILIATIONS_UPDATE = "ALD_AFFILIATIONS_UPDATE";

//ALD location types
export const REQUEST_LOCATION_ALD = "REQUEST_LOCATION_ALD";
export const RESPONSE_LOCATION_ALD = "RESPONSE_LOCATION_ALD";
export const FAILURE_LOCATION_ALD = "FAILURE_LOCATION_ALD";
export const LOCATION_UPDATE_ALD = "LOCATION_UPDATE_ALD";

//ALD location table
export const REQUEST_LOCATION_TABLE_ALD = "REQUEST_LOCATION_TABLE_ALD";
export const RESPONSE_LOCATION_TABLE_ALD = "RESPONSE_LOCATION_TABLE_ALD";
export const FAILURE_LOCATION_TABLE_ALD = "FAILURE_LOCATION_TABLE_ALD";

//ALD network ALD_NETWORK_RESPONSE,
export const ALD_NETWORK_RESPONSE = "ALD_NETWORK_RESPONSE";
export const ALD_NETWORK_FAILURE = "ALD_NETWORK_FAILURE";
export const ALD_NETWORK_REQUEST = "ALD_NETWORK_REQUEST";
export const ALD_NETWORK_SELECT_EXPERTS = "ALD_NETWORK_SELECT_EXPERTS";
//ALD trials
export const REQUEST_ALD_TRIALS_EXPERTS = "REQUEST_ALD_TRIALS_EXPERTS";
export const RESPONSE_ALD_TRIALS_EXPERTS = "RESPONSE_ALD_TRIALS_EXPERTS";
export const FAILURE_ALD_TRIALS_EXPERTS = "FAILURE_ALD_TRIALS_EXPERTS";

export const REQUEST_ALD_TRIALS_INSTITUTE = "REQUEST_ALD_TRIALS_INSTITUTE";
export const RESPONSE_ALD_TRIALS_INSTITUTE = "RESPONSE_ALD_TRIALS_INSTITUTE";
export const FAILURE_ALD_TRIALS_INSTITUTE = "FAILURE_ALD_TRIALS_INSTITUTE";

export const REQUEST_ALD_TRIALS_COUNTRY = "REQUEST_ALD_TRIALS_COUNTRY";
export const RESPONSE_ALD_TRIALS_COUNTRY = "RESPONSE_ALD_TRIALS_COUNTRY";
export const FAILURE_ALD_TRIALS_COUNTRY = "FAILURE_ALD_TRIALS_COUNTRY";

export const UPDATE_ALD_CLINICAL_TRIAL_FILTER =
  "UPDATE_ALD_CLINICAL_TRIAL_FILTER";

//ALD summaries
export const REQUEST_ALD_SUMMARY = "REQUEST_ALD_SUMMARY";
export const RESPONSE_ALD_SUMMARY = "RESPONSE_ALD_SUMMARY";
export const FAILURE_ALD_SUMMARY = "FAILURE_ALD_SUMMARY";

//kol mapping
export const REQUEST_KOL_MAPPING = "REQUEST_KOL_MAPPING";
export const RESPONSE_KOL_MAPPING = "RESPONSE_KOL_MAPPING";
export const FAILURE_KOL_MAPPING = "FAILURE_KOL_MAPPING";
export const UPDATE_INTERNAL_KOL = "UPDATE_INTERNAL_KOL";
export const UPDATE_TARGET_KOL = "UPDATE_TARGET_KOL";
export const REQUEST_KOL_ARTICLES = "REQUEST_KOL_ARTICLES";
export const RESPONSE_KOL_ARTICLES = "RESPONSE_KOL_ARTICLES";
export const FAILUTE_KOL_ARTILCES = "FAILUTE_KOL_ARTILCES";
export const UPDATE_KOL_SELECTED_PAIRS = "UPDATE_KOL_SELECTED_PAIRS";
export const UPDATE_KOL_TERMS = "UPDATE_KOL_TERMS";
export const REQUEST_KOL_MAPPING_UPLOAD = "REQUEST_KOL_MAPPING_UPLOAD";
export const RESPONSE_KOL_MAPPING_UPLOAD = "RESPONSE_KOL_MAPPING_UPLOAD";
export const FAILURE_KOL_MAPPING_UPLOAD = "FAILURE_KOL_MAPPING_UPLOAD";
export const KOL_CLEAR_RESULTS = "KOL_CLEAR_RESULTS";

export const EURO_NETWORK_REQUEST = "EURO_NETWORK_REQUEST";
export const EURO_NETWORK_RESPONSE = "EURO_NETWORK_RESPONSE";
export const EURO_NETWORK_FAILURE = "EURO_NETWORK_FAILURE";

//trials
export const REQUEST_TRIALS_INSTITUTES = "REQUEST_TRIALS_INSTITUTES";
export const RESPONSE_TRIALS_INSTITUTES = "RESPONSE_TRIALS_INSTITUTES";
export const FAILURE_TRIALS_INSTITUTES = "FAILURE_TRIALS_INSTITUTES";
export const TRIALS_INSTITUTES_PAGINATE = "TRIALS_INSTITUTES_PAGINATE";

//trials end points
export const REQUEST_TRIALS_ENDPOINTS = "REQUEST_TRIALS_ENDPOINTS";
export const RESPONSE_TRIALS_ENDPOINTS = "RESPONSE_TRIALS_ENDPOINTS";
export const FAILURE_TRIALS_ENDPOINTS = "FAILURE_TRIALS_ENDPOINTS";

//trials main
export const REQUEST_TRIALS_MAIN_TRIALS = "REQUEST_TRIALS_MAIN_TRIALS";
export const RESPONSE_TRIALS_MAIN_TRIALS = "RESPONSE_TRIALS_MAIN_TRIALS";
export const FAILURE_TRIALS_MAIN_TRIALS = "FAILURE_TRIALS_MAIN_TRIALS";

//trials sites
export const REQUEST_TRIALS_SITES = "REQUEST_TRIALS_SITES";
export const RESPONSE_TRIALS_SITES = "RESPONSE_TRIALS_SITES";
export const FAILURE_TRIALS_SITES = "FAILURE_TRIALS_SITES";

//trials phases
export const REQUEST_TRIALS_PHASES = "REQUEST_TRIALS_PHASES";
export const RESPONSE_TRIALS_PHASES = "RESPONSE_TRIALS_PHASES";
export const FAILURE_TRIALS_PHASES = "FAILURE_TRIALS_PHASES";

//mld trials
export const REQUEST_MLD_TRIALS_EXPERTS = "REQUEST_MLD_TRIALS_EXPERTS";
export const RESPONSE_MLD_TRIALS_EXPERTS = "RESPONSE_MLD_TRIALS_EXPERTS";
export const FAILURE_MLD_TRIALS_EXPERTS = "FAILURE_MLD_TRIALS_EXPERTS";

export const REQUEST_MLD_TRIALS_INSTITUTE = "REQUEST_MLD_TRIALS_INSTITUTE";
export const RESPONSE_MLD_TRIALS_INSTITUTE = "RESPONSE_MLD_TRIALS_INSTITUTE";
export const FAILURE_MLD_TRIALS_INSTITUTE = "FAILURE_MLD_TRIALS_INSTITUTE";

export const REQUEST_MLD_TRIALS_COUNTRY = "REQUEST_MLD_TRIALS_COUNTRY";
export const RESPONSE_MLD_TRIALS_COUNTRY = "RESPONSE_MLD_TRIALS_COUNTRY";
export const FAILURE_MLD_TRIALS_COUNTRY = "FAILURE_MLD_TRIALS_COUNTRY";

export const UPDATE_MLD_CLINICAL_TRIAL_FILTER =
  "UPDATE_MLD_CLINICAL_TRIAL_FILTER";

//mld summaries
export const REQUEST_MLD_SUMMARY = "REQUEST_MLD_SUMMARY";
export const RESPONSE_MLD_SUMMARY = "RESPONSE_MLD_SUMMARY";
export const FAILURE_MLD_SUMMARY = "FAILURE_MLD_SUMMARY";

//nipt professionals
export const NIPT_PROFESSIONALS_RESPONSE = "NIPT_PROFESSIONALS_RESPONSE";
export const NIPT_PROFESSIONALS_FAILURE = "NIPT_PROFESSIONALS_FAILURE";
export const NIPT_PROFESSIONALS_REQUEST = "NIPT_PROFESSIONALS_REQUEST";
export const NIPT_PROFESSIONALS_UPDATE = "NIPT_PROFESSIONALS_UPDATE";
export const NIPT_PROFESSIONALS_UPDATE_FILTER =
  "NIPT_PROFESSIONALS_UPDATE_FILTER";

export const NIPT_PROFESSIONALS_SELECT = "NIPT_PROFESSIONALS_SELECT";
export const NIPT_PROFESSIONALS_REMOVE_SELECT =
  "NIPT_PROFESSIONALS_REMOVE_SELECT";
export const NIPT_PROFESSIONALS_SHORT_LIST_TOGGLE =
  "NIPT_PROFESSIONALS_SHORT_LIST_TOGGLE";
export const NIPT_PROFESSIONALS_SHORT_LIST_SAVE_REQUEST =
  "NIPT_PROFESSIONALS_SHORT_LIST_SAVE_REQUEST";
export const NIPT_PROFESSIONALS_SHORT_LIST_SAVE_RESPONSE =
  "NIPT_PROFESSIONALS_SHORT_LIST_SAVE_RESPONSE";
export const NIPT_PROFESSIONALS_SHORT_LIST_REMOVE_RESPONSE =
  "NIPT_PROFESSIONALS_SHORT_LIST_REMOVE_RESPONSE";

export const NIPT_SHORT_LIST_PROFESSIONALS_RESPONSE =
  "NIPT_SHORT_LIST_PROFESSIONALS_RESPONSE";
export const NIPT_SHORT_LIST_PROFESSIONALS_FAILURE =
  "NIPT_SHORT_LIST_PROFESSIONALS_FAILURE";
export const NIPT_SHORT_LIST_PROFESSIONALS_REQUEST =
  "NIPT_SHORT_LIST_PROFESSIONALS_REQUEST";
export const NIPT_SHORT_LIST_PROFESSIONALS_UPDATE =
  "NIPT_SHORT_LIST_PROFESSIONALS_UPDATE";

export const NIPT_PROFESSIONALS_SELECT_SHORT_LIST =
  "NIPT_PROFESSIONALS_SELECT_SHORT_LIST";
export const NIPT_PROFESSIONALS_REMOVE_SELECT_SHORT_LIST =
  "NIPT_PROFESSIONALS_REMOVE_SELECT_SHORT_LIST";
export const NIPT_PROFESSIONALS_SELECT_LIST_TOGGLE =
  "NIPT_PROFESSIONALS_SELECT_LIST_TOGGLE";
export const NIPT_PROFESSIONALS_SELECT_LIST_SAVE_REQUEST =
  "NIPT_PROFESSIONALS_SELECT_LIST_SAVE_REQUEST";
export const NIPT_PROFESSIONALS_SELECT_LIST_SAVE_RESPONSE =
  "NIPT_PROFESSIONALS_SELECT_LIST_SAVE_RESPONSE";

export const NIPT_SELECTED_LIST_PROFESSIONALS_RESPONSE =
  "NIPT_SELECTED_LIST_PROFESSIONALS_RESPONSE";
export const NIPT_SELECTED_LIST_PROFESSIONALS_FAILURE =
  "NIPT_SELECTED_LIST_PROFESSIONALS_FAILURE";
export const NIPT_SELECTED_LIST_PROFESSIONALS_REQUEST =
  "NIPT_SELECTED_LIST_PROFESSIONALS_REQUEST";
export const NIPT_SELECTED_LIST_PROFESSIONALS_UPDATE =
  "NIPT_SELECTED_LIST_PROFESSIONALS_UPDATE";

export const REQUEST_LOCATION_NIPT = "REQUEST_LOCATION_NIPT";
export const RESPONSE_LOCATION_NIPT = "RESPONSE_LOCATION_NIPT";
export const FAILURE_LOCATION_NIPT = "FAILURE_LOCATION_NIPT";

export const NIPT_AFFILIATIONS_RESPONSE = "NIPT_AFFILIATIONS_RESPONSE";
export const NIPT_AFFILIATIONS_FAILURE = "NIPT_AFFILIATIONS_FAILURE";
export const NIPT_AFFILIATIONS_REQUEST = "NIPT_AFFILIATIONS_REQUEST";
export const NIPT_AFFILIATIONS_UPDATE = "NIPT_AFFILIATIONS_UPDATE";

export const NIPT_NETWORK_RESPONSE = "NIPT_NETWORK_RESPONSE";
export const NIPT_NETWORK_FAILURE = "NIPT_NETWORK_FAILURE";
export const NIPT_NETWORK_REQUEST = "NIPT_NETWORK_REQUEST";
export const NIPT_NETWORK_SELECT_EXPERTS = "NIPT_NETWORK_SELECT_EXPERTS";

export const REQUEST_NIPT_SUMMARY = "REQUEST_NIPT_SUMMARY";
export const RESPONSE_NIPT_SUMMARY = "RESPONSE_NIPT_SUMMARY";
export const FAILURE_NIPT_SUMMARY = "FAILURE_NIPT_SUMMARY";

export const REQUEST_SUMMARY_LOCATION_NIPT = "REQUEST_SUMMARY_LOCATION_NIPT";
export const RESPONSE_SUMMARY_LOCATION_NIPT = "RESPONSE_SUMMARY_LOCATION_NIPT";
export const FAILURE_SUMMARY_LOCATION_NIPT = "FAILURE_SUMMARY_LOCATION_NIPT";

export const NIPT_PROFESSIONALS_SHORT_UPDATE_FILTER =
  "NIPT_PROFESSIONALS_SHORT_UPDATE_FILTER";
export const NIPT_PROFESSIONALS_SELECT_UPDATE_FILTER =
  "NIPT_PROFESSIONALS_SELECT_UPDATE_FILTER";

export const REQUEST_NIPT_TRIALS_INSTITUTE = "REQUEST_NIPT_TRIALS_INSTITUTE";
export const RESPONSE_NIPT_TRIALS_INSTITUTE = "RESPONSE_NIPT_TRIALS_INSTITUTE";
export const FAILURE_NIPT_TRIALS_INSTITUTE = "FAILURE_NIPT_TRIALS_INSTITUTE";

export const REQUEST_NIPT_TRIALS_EXPERTS = "REQUEST_NIPT_TRIALS_EXPERTS";
export const RESPONSE_NIPT_TRIALS_EXPERTS = "RESPONSE_NIPT_TRIALS_EXPERTS";
export const FAILURE_NIPT_TRIALS_EXPERTS = "FAILURE_NIPT_TRIALS_EXPERTS";

export const REQUEST_NIPT_TRIALS_COUNTRY = "REQUEST_NIPT_TRIALS_COUNTRY";
export const RESPONSE_NIPT_TRIALS_COUNTRY = "RESPONSE_NIPT_TRIALS_COUNTRY";
export const FAILURE_NIPT_TRIALS_COUNTRY = "FAILURE_NIPT_TRIALS_COUNTRY";

export const REQUEST_NIPT_TRIALS = "REQUEST_NIPT_TRIALS";
export const RESPONSE_NIPT_TRIALS = "RESPONSE_NIPT_TRIALS";
export const FAILURE_NIPT_TRIALS = "FAILURE_NIPT_TRIALS";
export const SORT_NIPT_CLINICAL_TRIAL = "SORT_NIPT_CLINICAL_TRIAL";
export const NIPT_CLINICAL_TRIAL_MORE_REQUEST =
  "NIPT_CLINICAL_TRIAL_MORE_REQUEST";
export const NIPT_CLINICAL_TRIAL_MORE_FAILURE =
  "NIPT_CLINICAL_TRIAL_MORE_FAILURE";
export const NIPT_CLINICAL_TRIAL_MORE_RESPONSE =
  "NIPT_CLINICAL_TRIAL_MORE_RESPONSE";

export const CHANGE_NIPT_CLINICAL_TRIAL_FILTER =
  "CHANGE_NIPT_CLINICAL_TRIAL_FILTER";
export const CLEAR_NIPT_CLINICAL_TRIAL_FILTER =
  "CLEAR_NIPT_CLINICAL_TRIAL_FILTER";
export const UPDATE_NIPT_CLINICAL_TRIAL_FILTER =
  "UPDATE_NIPT_CLINICAL_TRIAL_FILTER";

//nipt grants
export const REQUEST_NIPT_GRANTS = "REQUEST_NIPT_GRANTS";
export const RESPONSE_NIPT_GRANTS = "RESPONSE_NIPT_GRANTS";
export const UPDATE_NIPT_GRANTS_RESULT = "UPDATE_NIPT_GRANTS_RESULT";
export const FAILURE_NIPT_GRANTS = "FAILURE_NIPT_GRANTS";

export const RELATED_CONCEPTS_SYNONYMS_CHANGE =
  "RELATED_CONCEPTS_SYNONYMS_CHANGE";

export const RELATED_CONCEPTS_TERMS_CHANGE = "RELATED_CONCEPTS_TERMS_CHANGE";

export const RELATED_CONCEPTS_SYNONYMS_REQUEST =
  "RELATED_CONCEPTS_SYNONYMS_REQUEST";

export const RELATED_CONCEPTS_REQUEST = "RELATED_CONCEPTS_REQUEST";

export const FAILURE_ADD_CLINIC = "FAILURE_ADD_CLINIC";
export const RESPONSE_ADD_CLINIC = "RESPONSE_ADD_CLINIC";
export const REQUEST_ADD_CLINIC = "REQUEST_ADD_CLINIC";

export const ABSTRACT_CONCEPT_RESPONSE = "ABSTRACT_CONCEPT_RESPONSE";
export const ABSTRACT_CONCEPT_FAILURE = "ABSTRACT_CONCEPT_FAILURE";
export const ABSTRACT_CONCEPT_REQUEST = "ABSTRACT_CONCEPT_REQUEST";
export const ABSTRACT_CONCEPT_CHANGE = "ABSTRACT_CONCEPT_CHANGE";

//clinics
export const ROTA_CLINIC_GET_REQUEST = "ROTA_CLINIC_GET_REQUEST";
export const ROTA_CLINIC_GET_RESPONSE = "ROTA_CLINIC_GET_RESPONSE";
export const ROTA_CLINIC_GET_FAILURE = "ROTA_CLINIC_GET_FAILURE";
export const ROTA_CLINIC_DETAILS_GET_REQUEST =
  "ROTA_CLINIC_DETAILS_GET_REQUEST";
export const ROTA_CLINIC_DETAILS_GET_RESPONSE =
  "ROTA_CLINIC_DETAILS_GET_RESPONSE";
export const ROTA_CLINIC_DETAILS_UPDATE = "ROTA_CLINIC_DETAILS_UPDATE";

export const ROTA_CLINIC_ADD_REQUEST = "ROTA_CLINIC_ADD_REQUEST";
export const ROTA_CLINIC_ADD_RESPONSE = "ROTA_CLINIC_ADD_RESPONSE";
export const ROTA_CLINIC_ADD_FAILURE = "ROTA_CLINIC_ADD_FAILURE";

//doctors
export const ROTA_DOCTOR_GET_REQUEST = "ROTA_DOCTOR_GET_REQUEST";
export const ROTA_DOCTOR_GET_RESPONSE = "ROTA_DOCTOR_GET_RESPONSE";
export const ROTA_DOCTOR_GET_FAILURE = "ROTA_DOCTOR_GET_FAILURE";

export const ROTA_DOCTOR_ADD_REQUEST = "ROTA_DOCTOR_ADD_REQUEST";
export const ROTA_DOCTOR_ADD_RESPONSE = "ROTA_DOCTOR_ADD_RESPONSE";
export const ROTA_DOCTOR_ADD_FAILURE = "ROTA_DOCTOR_ADD_FAILURE";
export const ROTA_CLINIC_UPDATE = "ROTA_CLINIC_UPDATE";

//peer reviewer
export const PEER_REVIEWER_RESULT_RESPONSE = "PEER_REVIEWER_RESULT_RESPONSE";
export const PEER_REVIEWER_RESULT_FAILURE = "PEER_REVIEWER_RESULT_FAILURE";
export const PEER_REVIEWER_RESULT_REQUEST = "PEER_REVIEWER_RESULT_REQUEST";

export const PEER_REVIEWER_KEYWORD_RESPONSE = "PEER_REVIEWER_KEYWORD_RESPONSE";
export const PEER_REVIEWER_KEYWORD_FAILURE = "PEER_REVIEWER_KEYWORD_FAILURE";
export const PEER_REVIEWER_KEYWORD_REQUEST = "PEER_REVIEWER_KEYWORD_REQUEST";
export const PEER_REVIEWER_KEYWORD_UPDATE = "PEER_REVIEWER_KEYWORD_UPDATE";

export const PEER_REVIEWER_UPDATE_TITLE = "PEER_REVIEWER_UPDATE_TITLE";
export const PEER_REVIEWER_UPDATE_ABSTRACT = "PEER_REVIEWER_UPDATE_ABSTRACT";
export const PEER_REVIEWER_UPDATE_APPLICANT = "PEER_REVIEWER_UPDATE_APPLICANT";
export const PEER_REVIEWER_UPDATE_SELECTED_TOPICS =
  "PEER_REVIEWER_UPDATE_SELECTED_TOPICS";

export const PEER_REVIEWER_REQUEST_CONFLICT = "PEER_REVIEWER_REQUEST_CONFLICT";
export const PEER_REVIEWER_RESPONSE_CONFLICT =
  "PEER_REVIEWER_RESPONSE_CONFLICT";
export const PEER_REVIEWER_FAILURE_CONFLICT = "PEER_REVIEWER_FAILURE_CONFLICT";

//direct profile search
export const REQUEST_DIRECT_PROFILE_SEARCH = "REQUEST_DIRECT_PROFILE_SEARCH";
export const RESPONSE_DIRECT_PROFILE_SEARCH = "RESPONSE_DIRECT_PROFILE_SEARCH";
export const FAILURE_DIRECT_PROFILE_SEARCH = "FAILURE_DIRECT_PROFILE_SEARCH";

//rotav1
//rota doctors
export const REQUEST_ROTAV1_DOCTORS = "REQUEST_ROTAV1_DOCTORS";
export const RESPONSE_ROTAV1_DOCTORS = "RESPONSE_ROTAV1_DOCTORS";
export const FAILURE_ROTAV1_DOCTORS = "RESPONSE_ROTAV1_DOCTORS";

//rota management
//oncall
export const REQUEST_ROTAV1_MANAGEMENT_ONCALL =
  "REQUEST_ROTAV1_MANAGEMENT_ONCALL";
export const RESPONSE_ROTAV1_MANAGEMENT_ONCALL =
  "RESPONSE_ROTAV1_MANAGEMENT_ONCALL";
export const FAILURE_ROTAV1_MANAGEMENT_ONCALL =
  "FAILURE_ROTAV1_MANAGEMENT_ONCALL";

//leaves
export const REQUEST_ROTAV1_MANAGEMENT_LEAVES =
  "REQUEST_ROTAV1_MANAGEMENT_LEAVES";
export const RESPONSE_ROTAV1_MANAGEMENT_LEAVES =
  "RESPONSE_ROTAV1_MANAGEMENT_LEAVES";
export const FAILURE_ROTAV1_MANAGEMENT_LEAVES =
  "FAILURE_ROTAV1_MANAGEMENT_LEAVES";

//ROCKET PHARMA
//DANON
export const REQUEST_ROCKET_DANON_PATIENTS = "REQUEST_ROCKET_DANON_PATIENTS";
export const RESPONSE_ROCKET_DANON_PATIENTS = "RESPONSE_ROCKET_DANON_PATIENTS";
export const FAILURE_ROCKET_DANON_PATIENTS = "FAILURE_ROCKET_DANON_PATIENTS";
export const REQUEST_ROCKET_DANON_MBODIE = "REQUEST_ROCKET_DANON_MBODIE";
export const RESPONSE_ROCKET_DANON_MBODIE = "RESPONSE_ROCKET_DANON_MBODIE";
export const FAILURE_ROCKET_DANON_MBODIE = "FAILURE_ROCKET_DANON_MBODIE";
export const REQUEST_ROCKET_DANON_CONF = "REQUEST_ROCKET_DANON_CONF";
export const RESPONSE_ROCKET_DANON_CONF = "RESPONSE_ROCKET_DANON_CONF";
export const FAILURE_ROCKET_DANON_CONF = "FAILURE_ROCKET_DANON_CONF";

//LAD
export const REQUEST_ROCKET_LAD_PATIENTS = "REQUEST_ROCKET_LAD_PATIENTS";
export const RESPONSE_ROCKET_LAD_PATIENTS = "RESPONSE_ROCKET_LAD_PATIENTS";
export const FAILURE_ROCKET_LAD_PATIENTS = "FAILURE_ROCKET_LAD_PATIENTS";
export const REQUEST_ROCKET_LAD_CONF = "REQUEST_ROCKET_LAD_CONF";
export const RESPONSE_ROCKET_LAD_CONF = "RESPONSE_ROCKET_LAD_CONF";
export const FAILURE_ROCKET_LAD_CONF = "FAILURE_ROCKET_LAD_CONF";
export const REQUEST_ROCKET_LAD_MBODIE = "REQUEST_ROCKET_LAD_MBODIE";
export const RESPONSE_ROCKET_LAD_MBODIE = "RESPONSE_ROCKET_LAD_MBODIE";
export const FAILURE_ROCKET_LAD_MBODIE = "FAILURE_ROCKET_LAD_MBODIE";

//CRO
export const REQUEST_ROCKET_CROS = "REQUEST_ROCKET_CROS";
export const RESPONSE_ROCKET_CROS = "RESPONSE_ROCKET_CROS";
export const FAILURE_ROCKET_CROS = "FAILURE_ROCKET_CROS";

//ALACRITA
export const REQUEST_LGMD2C = "REQUEST_LGMD2C";
export const RESPONSE_LGMD2C = "RESPONSE_LGMD2C";
export const FAILURE_LGMD2C = "FAILURE_LGMD2C";

//ALACRITA DEFINITIONS
export const REQUEST_ALACRITA_DEFINITIONS = "REQUEST_ALACRITA_DEFINITIONS";
export const RESPONSE_ALACRITA_DEFINITIONS = "RESPONSE_ALACRITA_DEFINITIONS";
export const UPDATE_ALACRITA_DEFINITIONS = "UPDATE_ALACRITA_DEFINITIONS";
export const FAILURE_ALACRITA_DEFINITIONS = "FAILURE_ALACRITA_DEFINITIONS";

//ALACRITA EPIDEMIOLOGY
export const REQUEST_ALACRITA_EPIDEMIOLOGY = "REQUEST_ALACRITA_EPIDEMIOLOGY";
export const RESPONSE_ALACRITA_EPIDEMIOLOGY = "RESPONSE_ALACRITA_EPIDEMIOLOGY";
export const FAILURE_ALACRITA_EPIDEMIOLOGY = "FAILURE_ALACRITA_EPIDEMIOLOGY";

//ALACRITA TRIAL SITES
export const REQUEST_ALACRITA_TRIAL_SITES = "REQUEST_ALACRITA_TRIAL_SITES";
export const RESPONSE_ALACRITA_TRIAL_SITES = "RESPONSE_ALACRITA_TRIAL_SITES";
export const FAILURE_ALACRITA_TRIAL_SITES = "FAILURE_ALACRITA_TRIAL_SITES";

//NIPT MEDICAL BODIES
export const REQUEST_NIPT_MEDICAL_BODIES = "REQUEST_NIPT_MEDICAL_BODIES";
export const RESPONSE_NIPT_MEDICAL_BODIES = "RESPONSE_NIPT_MEDICAL_BODIES";
export const UPDATE_NIPT_RESULTS = "UPDATE_NIPT_RESULTS";
export const FAILURE_NIPT_MEDICAL_BODIES = "FAILURE_NIPT_MEDICAL_BODIES";

//NIPT CONF
export const REQUEST_NIPT_CONF = "REQUEST_NIPT_CONF";
export const RESPONSE_NIPT_CONF = "RESPONSE_NIPT_CONF";
export const FAILURE_NIPT_CONF = "FAILURE_NIPT_CONF";

//NIPT FUNDING ORG
export const REQUEST_NIPT_FUNDING_ORG = "REQUEST_NIPT_FUNDING_ORG";
export const RESPONSE_NIPT_FUNDING_ORG = "RESPONSE_NIPT_FUNDING_ORG";
export const FAILURE_NIPT_FUNDING_ORG = "FAILURE_NIPT_FUNDING_ORG";

//TERMS SPECIFIC TRIALS
export const REQUEST_TERMS_TRIALS_MAIN_TRIALS =
  "REQUEST_TERMS_TRIALS_MAIN_TRIALS";
export const RESPONSE_TERMS_TRIALS_MAIN_TRIALS =
  "RESPONSE_TERMS_TRIALS_MAIN_TRIALS";
export const FAILURE_TERMS_TRIALS_MAIN_TRIALS =
  "FAILURE_TERMS_TRIALS_MAIN_TRIALS";

//AFFILIATION SEARCH
export const REQUEST_DIRECT_AFFILIATION_SEARCH =
  "REQUEST_DIRECT_AFFILIATION_SEARCH";
export const RESPONSE_DIRECT_AFFILIATION_SEARCH =
  "RESPONSE_DIRECT_AFFILIATION_SEARCH";
export const FAILURE_DIRECT_AFFILIATION_SEARCH =
  "FAILURE_DIRECT_AFFILIATION_SEARCH";
export const RESPONSE_DIRECT_AFFILIATION_SEARCH_TERMS =
  "RESPONSE_DIRECT_AFFILIATION_SEARCH_TERMS";
export const RESPONSE_DIRECT_AFFILIATION_SEARCH_TWEETS =
  "RESPONSE_DIRECT_AFFILIATION_SEARCH_TWEETS";
export const RESPONSE_DIRECT_AFFILIATION_SEARCH_ORGS =
  "RESPONSE_DIRECT_AFFILIATION_SEARCH_ORGS";

//PEOPLE SIMILARITY
export const PERSON_SIMILARITY_RESULT_RESPONSE =
  "PERSON_SIMILARITY_RESULT_RESPONSE";
export const PERSON_SIMILARITY_RESULT_FAILURE =
  "PERSON_SIMILARITY_RESULT_FAILURE";
export const PERSON_SIMILARITY_RESULT_REQUEST =
  "PERSON_SIMILARITY_RESULT_REQUEST";
export const PERSON_SIMILARITY_KEYWORD_UPDATE =
  "PERSON_SIMILARITY_KEYWORD_UPDATE";

//MLD TWEETS
export const REQUEST_MLD_TWEET_SUMMARY = "REQUEST_MLD_TWEET_SUMMARY";
export const RESPONSE_MLD_TWEET_SUMMARY = "RESPONSE_MLD_TWEET_SUMMARY";
export const FAILURE_MLD_TWEET_SUMMARY = "FAILURE_MLD_TWEET_SUMMARY";

export const REQUEST_MLD_TWEET_USERS = "REQUEST_MLD_TWEET_USERS";
export const RESPONSE_MLD_TWEET_USERS = "RESPONSE_MLD_TWEET_USERS";
export const FAILURE_MLD_TWEET_USERS = "RESPONSE_MLD_TWEET_USERS";

export const REQUEST_MLD_TWEET_SENTIMENT = "REQUEST_MLD_TWEET_SENTIMENT";
export const RESPONSE_MLD_TWEET_SENTIMENT = "RESPONSE_MLD_TWEET_SENTIMENT";
export const FAILURE_MLD_TWEET_SENTIMENT = "FAILURE_MLD_TWEET_SENTIMENT";

export const REQUEST_MLD_TWEET_RELATED_USERS =
  "REQUEST_MLD_TWEET_RELATED_USERS";
export const RESPONSE_MLD_TWEET_RELATED_USERS =
  "RESPONSE_MLD_TWEET_RELATED_USERS";
export const FAILURE_MLD_TWEET_RELATED_USERS =
  "FAILURE_MLD_TWEET_RELATED_USERS";

export const REQUEST_MLD_TWEET_HANDLER = "REQUEST_MLD_TWEET_HANDLER";
export const RESPONSE_MLD_TWEET_HANDLER = "RESPONSE_MLD_TWEET_HANDLER";
export const FAILURE_MLD_TWEET_HANDLER = "FAILURE_MLD_TWEET_HANDLER";
export const RESPONSE_MLD_HANDLER_TWEET_NETWORK =
  "RESPONSE_MLD_HANDLER_TWEET_NETWORK";

export const REQUEST_MLD_TWEET_RELATED_TERMS =
  "REQUEST_MLD_TWEET_RELATED_TERMS";
export const RESPONSE_MLD_TWEET_RELATED_TERMS =
  "RESPONSE_MLD_TWEET_RELATED_TERMS";
export const FAILURE_MLD_TWEET_RELATED_TERMS =
  "FAILURE_MLD_TWEET_RELATED_TERMS";

//main experts page
export const REQUEST_MAIN_EXPERTS_SEARCH = "REQUEST_MAIN_EXPERTS_SEARCH";
export const RESPONSE_MAIN_EXPERTS_SEARCH = "RESPONSE_MAIN_EXPERTS_SEARCH";
export const FAILURE_MAIN_EXPERTS_SEARCH = "FAILURE_MAIN_EXPERTS_SEARCH";
export const RESPONSE_MAIN_EXPERTS_SEARCH_ORGS =
  "RESPONSE_MAIN_EXPERTS_SEARCH_ORGS";
export const RESPONSE_MAIN_EXPERTS_SEARCH_TWEETS =
  "RESPONSE_MAIN_EXPERTS_SEARCH_TWEETS";
export const RESPONSE_MAIN_EXPERTS_SEARCH_TERMS =
  "RESPONSE_MAIN_EXPERTS_SEARCH_TERMS";
export const UPDATE_MAIN_EXPERTS_SEARCH_SORT =
  "UPDATE_MAIN_EXPERTS_SEARCH_SORT";
export const UPDATE_MAIN_EXPERT_TEMP_KEYWORDS = "UPDATE_MAIN_EXPERT_TEMP_KEYWORDS"; 

//NEW MLD REDUCER BLOCKS
//MLD EXPERTS
export const REQUEST_MLD_MAIN_EXPERTS_SEARCH =
  "REQUEST_MLD_MAIN_EXPERTS_SEARCH";
export const RESPONSE_MLD_MAIN_EXPERTS_SEARCH =
  "RESPONSE_MLD_MAIN_EXPERTS_SEARCH";
export const FAILURE_MLD_MAIN_EXPERTS_SEARCH =
  "FAILURE_MLD_MAIN_EXPERTS_SEARCH";
export const UPDATE_MLD_MAIN_EXPERTS_SEARCH_FILTER =
  "UPDATE_MLD_MAIN_EXPERTS_SEARCH_FILTER";
export const TOGGLE_MLD_SAVE_MODE = "TOGGLE_MLD_SAVE_MODE";
export const UPDATE_MLD_SAVE_LIST_ITEMS = "UPDATE_MLD_SAVE_LIST_ITEMS";
export const UPDATE_MLD_SAVE_LIST_TYPE = "UPDATE_MLD_SAVE_LIST_TYPE";
export const MLD_LOCATION_SUMMARY_UPDATE = "MLD_LOCATION_SUMMARY_UPDATE";

//NEW MAIN EXPERTS REDUCER
export const TOGGLE_MAIN_EXPERTS_SAVE_MODE = "TOGGLE_MAIN_EXPERTS_SAVE_MODE";
export const UPDATE_MAIN_EXPERTS_SAVE_LIST_ITEMS =
  "UPDATE_MAIN_EXPERTS_SAVE_LIST_ITEMS";
export const UPDATE_MAIN_EXPERTS_SAVE_LIST_TYPE =
  "UPDATE_MAIN_EXPERTS_SAVE_LIST_TYPE";
export const RESPONSE_MAIN_EXPERTS_SEARCH_DEFS =
  "RESPONSE_MAIN_EXPERTS_SEARCH_DEFS";

//WAS ACTION TYPES
export const REQUEST_WAS_MAIN_EXPERTS_SEARCH =
  "REQUEST_WAS_MAIN_EXPERTS_SEARCH";
export const RESPONSE_WAS_MAIN_EXPERTS_SEARCH =
  "RESPONSE_WAS_MAIN_EXPERTS_SEARCH";
export const FAILURE_WAS_MAIN_EXPERTS_SEARCH =
  "FAILURE_WAS_MAIN_EXPERTS_SEARCH";
export const UPDATE_WAS_MAIN_EXPERTS_SEARCH_FILTER =
  "UPDATE_WAS_MAIN_EXPERTS_SEARCH_FILTER";
export const TOGGLE_WAS_SAVE_MODE = "TOGGLE_WAS_SAVE_MODE";
export const UPDATE_WAS_SAVE_LIST_ITEMS = "UPDATE_WAS_SAVE_LIST_ITEMS";
export const UPDATE_WAS_SAVE_LIST_TYPE = "UPDATE_WAS_SAVE_LIST_TYPE";
export const WAS_PROFESSIONALS_UPDATE_FILTER =
  "WAS_PROFESSIONALS_UPDATE_FILTER";

//WAS LOCATION TYPES
export const REQUEST_SUMMARY_LOCATION_WAS = "REQUEST_SUMMARY_LOCATION_WAS";
export const RESPONSE_SUMMARY_LOCATION_WAS = "RESPONSE_SUMMARY_LOCATION_WAS";
export const FAILURE_SUMMARY_LOCATION_WAS = "FAILURE_SUMMARY_LOCATION_WAS";
export const WAS_LOCATION_SUMMARY_UPDATE = "WAS_LOCATION_SUMMARY_UPDATE";

//WAS AFFILIATION TYPES
export const WAS_AFFILIATIONS_RESPONSE = "WAS_AFFILIATIONS_RESPONSE";
export const WAS_AFFILIATIONS_FAILURE = "WAS_AFFILIATIONS_FAILURE";
export const WAS_AFFILIATIONS_REQUEST = "WAS_AFFILIATIONS_REQUEST";
export const WAS_AFFILIATIONS_UPDATE = "WAS_AFFILIATIONS_UPDATE";

//WAS COLLABS NETWORK
export const WAS_NETWORK_RESPONSE = "WAS_NETWORK_RESPONSE";
export const WAS_NETWORK_FAILURE = "WAS_NETWORK_FAILURE";
export const WAS_NETWORK_REQUEST = "WAS_NETWORK_REQUEST";
export const WAS_NETWORK_SELECT_EXPERTS = "WAS_NETWORK_SELECT_EXPERTS";
export const WAS_NETWORK_FILTER_UPDATE = "WAS_NETWORK_FILTER_UPDATE";
export const WAS_NETWORK_RESULT_STATE_UPDATE = "WAS_NETWORK_RESULT_STATE_UPDATE";

//WAS MEDICAL BODIES
export const REQUEST_WAS_MEDICAL_BODIES = "REQUEST_WAS_MEDICAL_BODIES";
export const RESPONSE_WAS_MEDICAL_BODIES = "RESPONSE_WAS_MEDICAL_BODIES";
export const UPDATE_WAS_RESULTS = "UPDATE_WAS_RESULTS";
export const FAILURE_WAS_MEDICAL_BODIES = "FAILURE_WAS_MEDICAL_BODIES";

//WAS CONFS
export const REQUEST_WAS_CONFS = "REQUEST_WAS_CONFS";
export const RESPONSE_WAS_CONFS = "RESPONSE_WAS_CONFS";
export const UPDATE_WAS_CONF_RESULTS = "UPDATE_WAS_CONF_RESULTS";
export const FAILURE_WAS_CONFS = "FAILURE_WAS_CONFS";

//WAS CLINICAL TRIALS
export const SORT_WAS_CLINICAL_TRIAL = "SORT_WAS_CLINICAL_TRIAL";
export const CLEAR_WAS_CLINICAL_TRIAL_FILTER =
  "CLEAR_WAS_CLINICAL_TRIAL_FILTER";
export const UPDATE_WAS_CLINICAL_TRIAL_FILTER =
  "UPDATE_WAS_CLINICAL_TRIAL_FILTER";
export const REQUEST_WAS_TRIALS = "REQUEST_WAS_TRIALS";
export const RESPONSE_WAS_TRIALS = "RESPONSE_WAS_TRIALS";
export const FAILURE_WAS_TRIALS = "FAILURE_WAS_TRIALS";
export const CHANGE_WAS_CLINICAL_TRIAL_FILTER =
  "const REQUEST_WAS_TRIALS_COUNTRY";
export const REQUEST_WAS_TRIALS_COUNTRY = "REQUEST_WAS_TRIALS_COUNTRY";
export const RESPONSE_WAS_TRIALS_COUNTRY = "RESPONSE_WAS_TRIALS_COUNTRY";
export const FAILURE_WAS_TRIALS_COUNTRY = "FAILURE_WAS_TRIALS_COUNTRY";

export const REQUEST_WAS_TRIALS_EXPERTS = "REQUEST_WAS_TRIALS_EXPERTS";
export const RESPONSE_WAS_TRIALS_EXPERTS = "RESPONSE_WAS_TRIALS_EXPERTS";
export const FAILURE_WAS_TRIALS_EXPERTS = "FAILURE_WAS_TRIALS_EXPERTS";

export const REQUEST_WAS_TRIALS_INSTITUTE = "REQUEST_WAS_TRIALS_INSTITUTE";
export const RESPONSE_WAS_TRIALS_INSTITUTE = "RESPONSE_WAS_TRIALS_INSTITUTE";
export const FAILURE_WAS_TRIALS_INSTITUTE = "FAILURE_WAS_TRIALS_INSTITUTE";

export const WAS_CLINICAL_TRIAL_MORE_REQUEST =
  "WAS_CLINICAL_TRIAL_MORE_REQUEST";
export const WAS_CLINICAL_TRIAL_MORE_FAILURE =
  "WAS_CLINICAL_TRIAL_MORE_FAILURE";
export const WAS_CLINICAL_TRIAL_MORE_RESPONSE =
  "WAS_CLINICAL_TRIAL_MORE_RESPONSE";

export const REQUEST_WAS_SUMMARY = "REQUEST_WAS_SUMMARY";
export const RESPONSE_WAS_SUMMARY = "RESPONSE_WAS_SUMMARY";
export const FAILURE_WAS_SUMMARY = "FAILURE_WAS_SUMMARY";

//ERN REF NETWORK
export const REQUEST_ERN_REF_NETWORK = "REQUEST_ERN_REF_NETWORK";
export const RESPONSE_ERN_REF_NETWORK = "RESPONSE_ERN_REF_NETWORK";
export const FAILURE_ERN_REF_NETWORK = "FAILURE_ERN_REF_NETWORK";

//RROFILE BASED COLLABS NETWORK
export const REQUEST_COLLABORATOR_NETWORK_PROFILE_BASED =
  "REQUEST_COLLABORATOR_NETWORK_PROFILE_BASED";
export const RESPONSE_COLLABORATOR_NETWORK_PROFILE_BASED =
  "RESPONSE_COLLABORATOR_NETWORK_PROFILE_BASED";
export const FAILURE_COLLABORATOR_NETWORK_PROFILE_BASED =
  "FAILURE_COLLABORATOR_NETWORK_PROFILE_BASED";
export const RESPONSE_COLLABORATOR_NETWORK_PROFILE_BASED_SUGGESTION =
  "RESPONSE_COLLABORATOR_NETWORK_PROFILE_BASED_SUGGESTION";
export const FAILURE_COLLABORATOR_NETWORK_PROFILE_BASED_SUGGESTION =
  "FAILURE_COLLABORATOR_NETWORK_PROFILE_BASED_SUGGESTION";
export const REQUEST_COLLABORATOR_NETWORK_PROFILE_BASED_SUGGESTION =
  "REQUEST_COLLABORATOR_NETWORK_PROFILE_BASED_SUGGESTION";

//NEW NIPT ACTION TYPES
export const REQUEST_NIPTAPP_MAIN_EXPERTS_SEARCH =
  "REQUEST_NIPTAPP_MAIN_EXPERTS_SEARCH";
export const RESPONSE_NIPTAPP_MAIN_EXPERTS_SEARCH =
  "RESPONSE_NIPTAPP_MAIN_EXPERTS_SEARCH";
export const FAILURE_NIPTAPP_MAIN_EXPERTS_SEARCH =
  "FAILURE_NIPTAPP_MAIN_EXPERTS_SEARCH";
export const UPDATE_NIPTAPP_MAIN_EXPERTS_SEARCH_FILTER =
  "UPDATE_NIPTAPP_MAIN_EXPERTS_SEARCH_FILTER";
export const NIPTAPP_PROFESSIONALS_UPDATE_FILTER =
  "NIPTAPP_PROFESSIONALS_UPDATE_FILTER";
export const TOGGLE_NIPTAPP_SAVE_MODE = "TOGGLE_NIPTAPP_SAVE_MODE";
export const UPDATE_NIPTAPP_SAVE_LIST_ITEMS = "UPDATE_NIPTAPP_SAVE_LIST_ITEMS";
export const UPDATE_NIPTAPP_SAVE_LIST_TYPE = "UPDATE_NIPTAPP_SAVE_LIST_TYPE";
export const NIPTAPP_AFFILIATIONS_RESPONSE = "NIPTAPP_AFFILIATIONS_RESPONSE";
export const NIPTAPP_AFFILIATIONS_FAILURE = "NIPTAPP_AFFILIATIONS_FAILURE";
export const NIPTAPP_AFFILIATIONS_REQUEST = "NIPTAPP_AFFILIATIONS_REQUEST";
export const NIPTAPP_AFFILIATIONS_UPDATE = "NIPTAPP_AFFILIATIONS_UPDATE";
export const REQUEST_SUMMARY_LOCATION_NIPTAPP =
  "REQUEST_SUMMARY_LOCATION_NIPTAPP";
export const RESPONSE_SUMMARY_LOCATION_NIPTAPP =
  "RESPONSE_SUMMARY_LOCATION_NIPTAPP";
export const FAILURE_SUMMARY_LOCATION_NIPTAPP =
  "FAILURE_SUMMARY_LOCATION_NIPTAPP";
export const NIPTAPP_LOCATION_SUMMARY_UPDATE =
  "NIPTAPP_LOCATION_SUMMARY_UPDATE";
export const REQUEST_NIPTAPP_SUMMARY = "REQUEST_NIPTAPP_SUMMARY";
export const RESPONSE_NIPTAPP_SUMMARY = "RESPONSE_NIPTAPP_SUMMARY";
export const FAILURE_NIPTAPP_SUMMARY = "FAILURE_NIPTAPP_SUMMARY";

export const NIPTAPP_NETWORK_RESPONSE = "NIPTAPP_NETWORK_RESPONSE";
export const NIPTAPP_NETWORK_FAILURE = "NIPTAPP_NETWORK_FAILURE";
export const NIPTAPP_NETWORK_REQUEST = "NIPTAPP_NETWORK_REQUEST";
export const NIPTAPP_NETWORK_SELECT_EXPERTS = "NIPTAPP_NETWORK_SELECT_EXPERTS";
export const NIPTAPP_NETWORK_FILTER_UPDATE = "NIPTAPP_NETWORK_FILTER_UPDATE";

export const REQUEST_NIPTAPP_TRIALS_INSTITUTE =
  "REQUEST_NIPTAPP_TRIALS_INSTITUTE";
export const RESPONSE_NIPTAPP_TRIALS_INSTITUTE =
  "RESPONSE_NIPTAPP_TRIALS_INSTITUTE";
export const FAILURE_NIPTAPP_TRIALS_INSTITUTE =
  "FAILURE_NIPTAPP_TRIALS_INSTITUTE";
export const REQUEST_NIPTAPP_TRIALS_EXPERTS = "REQUEST_NIPTAPP_TRIALS_EXPERTS";
export const RESPONSE_NIPTAPP_TRIALS_EXPERTS =
  "RESPONSE_NIPTAPP_TRIALS_EXPERTS";
export const FAILURE_NIPTAPP_TRIALS_EXPERTS = "FAILURE_NIPTAPP_TRIALS_EXPERTS";

export const REQUEST_NIPTAPP_TRIALS_COUNTRY = "REQUEST_NIPTAPP_TRIALS_COUNTRY";
export const RESPONSE_NIPTAPP_TRIALS_COUNTRY =
  "RESPONSE_NIPTAPP_TRIALS_COUNTRY";
export const FAILURE_NIPTAPP_TRIALS_COUNTRY = "FAILURE_NIPTAPP_TRIALS_COUNTRY";

export const REQUEST_NIPTAPP_TRIALS = "REQUEST_NIPTAPP_TRIALS";
export const RESPONSE_NIPTAPP_TRIALS = "RESPONSE_NIPTAPP_TRIALS";
export const FAILURE_NIPTAPP_TRIALS = "FAILURE_NIPTAPP_TRIALS";
export const SORT_NIPTAPP_CLINICAL_TRIAL = "SORT_NIPTAPP_CLINICAL_TRIAL";
export const NIPTAPP_CLINICAL_TRIAL_MORE_REQUEST =
  "NIPTAPP_CLINICAL_TRIAL_MORE_REQUEST";
export const NIPTAPP_CLINICAL_TRIAL_MORE_FAILURE =
  "NIPTAPP_CLINICAL_TRIAL_MORE_FAILURE";
export const NIPTAPP_CLINICAL_TRIAL_MORE_RESPONSE =
  "NIPTAPP_CLINICAL_TRIAL_MORE_RESPONSE";
export const CHANGE_NIPTAPP_CLINICAL_TRIAL_FILTER =
  "CHANGE_NIPTAPP_CLINICAL_TRIAL_FILTER";

export const CLEAR_NIPTAPP_CLINICAL_TRIAL_FILTER =
  "CLEAR_NIPTAPP_CLINICAL_TRIAL_FILTER";
export const UPDATE_NIPTAPP_CLINICAL_TRIAL_FILTER =
  "UPDATE_NIPTAPP_CLINICAL_TRIAL_FILTER";


//dashboard
export const REQUEST_DASHBOARD = "REQUEST_DASHBOARD";
export const RESPONSE_DASHBOARD = "RESPONSE_DASHBOARD";
export const FAILURE_DASHBOARD = "FAILURE_DASHBOARD";
export const UPDATE_DASHBOAR_FILTERS = "UPDATE_DASHBOAR_FILTERS";
export const UPDATE_DASHBOAR_NEW_UPDATES = "UPDATE_DASHBOAR_NEW_UPDATES";

//general dashboard
export const REQUEST_GENERAL_DASHBOARD = "REQUEST_GENERAL_DASHBOARD";
export const RESPONSE_GENERAL_DASHBOARD = "RESPONSE_GENERAL_DASHBOARD";
export const FAILURE_GENERAL_DASHBOARD = "FAILURE_GENERAL_DASHBOARD";  

// general congresses
export const REQUEST_GENERAL_MAIN_CONGRESSES_SEARCH = "REQUEST_GENERAL_MAIN_CONGRESSES_SEARCH";
export const RESPONSE_GENERAL_MAIN_CONGRESSES_SEARCH = "RESPONSE_GENERAL_MAIN_CONGRESSES_SEARCH";
export const FAILURE_GENERAL_MAIN_CONGRESSES_SEARCH = "FAILURE_GENERAL_MAIN_CONGRESSES_SEARCH";
export const UPDATE_GENERAL_MAIN_CONGRESSES_SEARCH_FILTER = "UPDATE_GENERAL_MAIN_CONGRESSES_SEARCH_FILTER";
export const GENERAL_CONGRESSES_PROFESSIONALS_UPDATE_FILTER = "GENERAL_CONGRESSES_PROFESSIONALS_UPDATE_FILTER";
export const TOGGLE_GENERAL_CONGRESSES_SAVE_MODE = "TOGGLE_GENERAL_CONGRESSES_SAVE_MODE";
export const UPDATE_GENERAL_CONGRESSES_SAVE_LIST_ITEMS = "UPDATE_GENERAL_CONGRESSES_SAVE_LIST_ITEMS";
export const UPDATE_GENERAL_CONGRESSES_SAVE_LIST_TYPE = "UPDATE_GENERAL_CONGRESSES_SAVE_LIST_TYPE";

// classified congresses
export const REQUEST_CLASSIFIED_CONGRESSES = "REQUEST_CLASSIFIED_CONGRESSES";
export const RESPONSE_CLASSIFIED_CONGRESSES = "RESPONSE_CLASSIFIED_CONGRESSES";
export const FAILURE_CLASSIFIED_CONGRESSES = "FAILURE_CLASSIFIED_CONGRESSES";

// general medical-bodies
export const REQUEST_GENERAL_MEDICAL_BODIES = "REQUEST_GENERAL_MEDICAL_BODIES";
export const RESPONSE_GENERAL_MEDICAL_BODIES = "RESPONSE_GENERAL_MEDICAL_BODIES";
export const FAILURE_GENERAL_MEDICAL_BODIES = "FAILURE_GENERAL_MEDICAL_BODIES";
export const GENERAL_KEYWORD_CHANGE = "GENERAL_KEYWORD_CHANGE";
export const UPDATE_GENERAL_MEDICAL_BODIES_RESULTS = "UPDATE_GENERAL_MEDICAL_BODIES_RESULTS";

//rare diseases
export const REQUEST_RARE_DISEASE = "REQUEST_RARE_DISEASE";
export const RESPONSE_RARE_DISEASE = "RESPONSE_RARE_DISEASE";
export const FAILURE_RARE_DISEASE = "FAILURE_RARE_DISEASE";
export const REQUEST_RARE_DISEASE_TWEETS = "REQUEST_RARE_DISEASE_TWEETS";
export const RESPONSE_RARE_DISEASE_TWEETS = "RESPONSE_RARE_DISEASE_TWEETS";
export const FAILURE_RARE_DISEASE_TWEETS = "FAILURE_RARE_DISEASE_TWEETS";
export const REQUEST_RARE_DISEASE_NETWORK = "REQUEST_RARE_DISEASE_NETWORK";
export const RESPONSE_RARE_DISEASE_NETWORK = "RESPONSE_RARE_DISEASE_NETWORK";
export const FAILURE_RARE_DISEASE_NETWORK = "FAILURE_RARE_DISEASE_NETWORK";
export const REQUEST_RARE_DISEASE_MORE_TWEETS = "REQUEST_RARE_DISEASE_MORE_TWEETS";
export const RESPONSE_RARE_DISEASE_MORE_TWEETS = "RESPONSE_RARE_DISEASE_MORE_TWEETS";
export const RARE_DISEASE_CLICKS = "RARE_DISEASE_CLICKS";


//zogenix
export const REQUEST_ZOGENIX_MAIN_EXPERTS_SEARCH = "REQUEST_ZOGENIX_MAIN_EXPERTS_SEARCH";
export const  RESPONSE_ZOGENIX_MAIN_EXPERTS_SEARCH = "RESPONSE_ZOGENIX_MAIN_EXPERTS_SEARCH";
export const  FAILURE_ZOGENIX_MAIN_EXPERTS_SEARCH = "FAILURE_ZOGENIX_MAIN_EXPERTS_SEARCH";
export const  UPDATE_ZOGENIX_MAIN_EXPERTS_SEARCH_FILTER = "UPDATE_ZOGENIX_MAIN_EXPERTS_SEARCH_FILTER";
export const  ZOGENIX_PROFESSIONALS_UPDATE_FILTER = "ZOGENIX_PROFESSIONALS_UPDATE_FILTER";
export const  TOGGLE_ZOGENIX_SAVE_MODE = "TOGGLE_ZOGENIX_SAVE_MODE";
export const  UPDATE_ZOGENIX_SAVE_LIST_ITEMS = "UPDATE_ZOGENIX_SAVE_LIST_ITEMS";
export const  UPDATE_ZOGENIX_SAVE_LIST_TYPE = "UPDATE_ZOGENIX_SAVE_LIST_TYPE";


export const ZOGENIX_CLINICAL_TRIAL_MORE_REQUEST = "ZOGENIX_CLINICAL_TRIAL_MORE_REQUEST";
export const ZOGENIX_CLINICAL_TRIAL_MORE_FAILURE = "ZOGENIX_CLINICAL_TRIAL_MORE_FAILURE";
export const ZOGENIX_CLINICAL_TRIAL_MORE_RESPONSE = "REQUEST_ZOGENIX_TRIALS_INSTITUTE";

export const   REQUEST_ZOGENIX_TRIALS_INSTITUTE = "REQUEST_ZOGENIX_TRIALS_INSTITUTE";
export const  RESPONSE_ZOGENIX_TRIALS_INSTITUTE = "RESPONSE_ZOGENIX_TRIALS_INSTITUTE";
export const  FAILURE_ZOGENIX_TRIALS_INSTITUTE = "FAILURE_ZOGENIX_TRIALS_INSTITUTE";

 export const   REQUEST_ZOGENIX_TRIALS_EXPERTS = "REQUEST_ZOGENIX_TRIALS_EXPERTS";
 export const RESPONSE_ZOGENIX_TRIALS_EXPERTS = "RESPONSE_ZOGENIX_TRIALS_EXPERTS";
export const  FAILURE_ZOGENIX_TRIALS_EXPERTS = "FAILURE_ZOGENIX_TRIALS_EXPERTS";


export const REQUEST_ZOGENIX_TRIALS_COUNTRY = "REQUEST_ZOGENIX_TRIALS_COUNTRY";
export const RESPONSE_ZOGENIX_TRIALS_COUNTRY = "RESPONSE_ZOGENIX_TRIALS_COUNTRY";
export const FAILURE_ZOGENIX_TRIALS_COUNTRY = "FAILURE_ZOGENIX_TRIALS_COUNTRY";
export const CHANGE_ZOGENIX_CLINICAL_TRIAL_FILTER = "CHANGE_ZOGENIX_CLINICAL_TRIAL_FILTER";


export const REQUEST_ZOGENIX_TRIALS = "REQUEST_ZOGENIX_TRIALS";
export const RESPONSE_ZOGENIX_TRIALS = "RESPONSE_ZOGENIX_TRIALS";
export const FAILURE_ZOGENIX_TRIALS ="FAILURE_ZOGENIX_TRIALS";
export const CLEAR_ZOGENIX_CLINICAL_TRIAL_FILTER = "CLEAR_ZOGENIX_CLINICAL_TRIAL_FILTER";
export const UPDATE_ZOGENIX_CLINICAL_TRIAL_FILTER = "UPDATE_ZOGENIX_CLINICAL_TRIAL_FILTER";


export const SORT_ZOGENIX_CLINICAL_TRIAL = "SORT_ZOGENIX_CLINICAL_TRIAL";

export const ZOGENIX_AFFILIATIONS_RESPONSE = "ZOGENIX_AFFILIATIONS_RESPONSE";
export const  ZOGENIX_AFFILIATIONS_FAILURE = "ZOGENIX_AFFILIATIONS_FAILURE";
export const  ZOGENIX_AFFILIATIONS_REQUEST = "ZOGENIX_AFFILIATIONS_REQUEST";
export const  ZOGENIX_AFFILIATIONS_UPDATE = "ZOGENIX_AFFILIATIONS_UPDATE";
export const ZOGENIX_AFFILIATIONS_EDIT_UPDATE = "ZOGENIX_AFFILIATIONS_EDIT_UPDATE";

//CARDIO
//zogenix
export const REQUEST_CARDIO_MAIN_EXPERTS_SEARCH = "REQUEST_CARDIO_MAIN_EXPERTS_SEARCH";
export const  RESPONSE_CARDIO_MAIN_EXPERTS_SEARCH = "RESPONSE_CARDIO_MAIN_EXPERTS_SEARCH";
export const  FAILURE_CARDIO_MAIN_EXPERTS_SEARCH = "FAILURE_CARDIO_MAIN_EXPERTS_SEARCH";
export const  UPDATE_CARDIO_MAIN_EXPERTS_SEARCH_FILTER = "UPDATE_CARDIO_MAIN_EXPERTS_SEARCH_FILTER";
export const  CARDIO_PROFESSIONALS_UPDATE_FILTER = "CARDIO_PROFESSIONALS_UPDATE_FILTER";
export const  TOGGLE_CARDIO_SAVE_MODE = "TOGGLE_CARDIO_SAVE_MODE";
export const  UPDATE_CARDIO_SAVE_LIST_ITEMS = "UPDATE_CARDIO_SAVE_LIST_ITEMS";
export const  UPDATE_CARDIO_SAVE_LIST_TYPE = "UPDATE_CARDIO_SAVE_LIST_TYPE";

export const REQUEST_CARDIO_MAIN_EXPERTS_SUMMARY_SEARCH = "REQUEST_CARDIO_MAIN_EXPERTS_SUMMARY_SEARCH";
export const RESPONSE_CARDIO_MAIN_EXPERTS_SUMMARY_SEARCH = "RESPONSE_CARDIO_MAIN_EXPERTS_SUMMARY_SEARCH";
export const FAILURE_CARDIO_MAIN_EXPERTS_SUMMARY_SEARCH = "FAILURE_CARDIO_MAIN_EXPERTS_SUMMARY_SEARCH";
export const UPDATE_CARDIO_MAIN_EXPERTS_SUMMARY_SEARCH_FILTER = "UPDATE_CARDIO_MAIN_EXPERTS_SUMMARY_SEARCH_FILTER"
export const CARDIO_EXPERTS_SUMMARY_PROFESSIONALS_UPDATE_FILTER = "CARDIO_EXPERTS_SUMMARY_PROFESSIONALS_UPDATE_FILTER";
export const TOGGLE_CARDIO_EXPERTS_SUMMARY_SAVE_MODE = "TOGGLE_CARDIO_EXPERTS_SUMMARY_SAVE_MODE";
export const UPDATE_CARDIO_EXPERTS_SUMMARY_SAVE_LIST_ITEMS = "UPDATE_CARDIO_EXPERTS_SUMMARY_SAVE_LIST_ITEMS";
export const UPDATE_CARDIO_EXPERTS_SUMMARY_SAVE_LIST_TYPE = "UPDATE_CARDIO_EXPERTS_SUMMARY_SAVE_LIST_TYPE";
export const UPDATE_CARDIO_EXPERTS_SUMMARY_COLUMNS = "UPDATE_CARDIO_EXPERTS_SUMMARY_COLUMNS";
export const UPDATE_CARDIO_EXPERTS_SUMMARY_CHECKBOX_FILTERS = "UPDATE_CARDIO_EXPERTS_SUMMARY_CHECKBOX_FILTERS";
export const UPDATE_CARDIO_EXPERTS_SUMMARY_MULTI_SORT = "UPDATE_CARDIO_EXPERTS_SUMMARY_MULTI_SORT";

// zogenix spain-dtl actions
export const REQUEST_ZOGENIX_SPAIN_SEARCH = "REQUEST_ZOGENIX_SPAIN_SEARCH";
export const RESPONSE_ZOGENIX_SPAIN_SEARCH = "RESPONSE_ZOGENIX_SPAIN_SEARCH";
export const FAILURE_ZOGENIX_SPAIN_SEARCH = "FAILURE_ZOGENIX_SPAIN_SEARCH";

//isns
export const REQUEST_ISNS = "REQUEST_ISNS";
export const RESPONSE_ISNS = "RESPONSE_ISNS";
export const FAILURE_ISNS = "RESPONSE_ISNS";
export const ISNS_CLICKS = "ISNS_CLICKS";
export const REQUEST_ISNS_PROFILE = "REQUEST_ISNS_PROFILE";
export const RESPONSE_ISNS_PROFILE = "RESPONSE_ISNS_PROFILE";
export const FAILURE_ISNS_PROFILE = "FAILURE_ISNS_PROFILE";


//covid
export const REQUEST_COVID_MAIN_EXPERTS_SEARCH = "REQUEST_COVID_MAIN_EXPERTS_SEARCH";
export const RESPONSE_COVID_MAIN_EXPERTS_SEARCH = "RESPONSE_COVID_MAIN_EXPERTS_SEARCH";
export const FAILURE_COVID_MAIN_EXPERTS_SEARCH = "FAILURE_COVID_MAIN_EXPERTS_SEARCH";
export const UPDATE_COVID_MAIN_EXPERTS_SEARCH_FILTER = "UPDATE_COVID_MAIN_EXPERTS_SEARCH_FILTER";
export const TOGGLE_COVID_SAVE_MODE = "TOGGLE_COVID_SAVE_MODE";
export const UPDATE_COVID_SAVE_LIST_ITEMS = "UPDATE_COVID_SAVE_LIST_ITEMS";
export const UPDATE_COVID_SAVE_LIST_TYPE = "UPDATE_COVID_SAVE_LIST_TYPE";
export const COVID_PROFESSIONALS_UPDATE_FILTER = "COVID_PROFESSIONALS_UPDATE_FILTER";


export const COVID_AFFILIATIONS_RESPONSE = "COVID_AFFILIATIONS_RESPONSE";
export const COVID_AFFILIATIONS_FAILURE = "COVID_AFFILIATIONS_FAILURE";
export const COVID_AFFILIATIONS_REQUEST = "COVID_AFFILIATIONS_REQUEST";
export const COVID_AFFILIATIONS_UPDATE = "COVID_AFFILIATIONS_UPDATE";

export const REQUEST_SUMMARY_LOCATION_COVID = "REQUEST_SUMMARY_LOCATION_COVID";
export const RESPONSE_SUMMARY_LOCATION_COVID = "RESPONSE_SUMMARY_LOCATION_COVID";
export const FAILURE_SUMMARY_LOCATION_COVID = "FAILURE_SUMMARY_LOCATION_COVID";
export const COVID_LOCATION_SUMMARY_UPDATE = "COVID_LOCATION_SUMMARY_UPDATE";

export const CHANGE_COVID_CLINICAL_TRIAL_FILTER = "CHANGE_COVID_CLINICAL_TRIAL_FILTER";
export const CLEAR_COVID_CLINICAL_TRIAL_FILTER = "CLEAR_COVID_CLINICAL_TRIAL_FILTER";
export const UPDATE_COVID_CLINICAL_TRIAL_FILTER = "UPDATE_COVID_CLINICAL_TRIAL_FILTER";

export const REQUEST_COVID_TRIALS = "REQUEST_COVID_TRIALS";
export const RESPONSE_COVID_TRIALS = "RESPONSE_COVID_TRIALS";
export const FAILURE_COVID_TRIALS = "FAILURE_COVID_TRIALS";
export const SORT_COVID_CLINICAL_TRIAL = "SORT_COVID_CLINICAL_TRIAL";
export const COVID_CLINICAL_TRIAL_MORE_REQUEST = "COVID_CLINICAL_TRIAL_MORE_REQUEST";
export const COVID_CLINICAL_TRIAL_MORE_FAILURE = "COVID_CLINICAL_TRIAL_MORE_FAILURE";
export const COVID_CLINICAL_TRIAL_MORE_RESPONSE = "COVID_CLINICAL_TRIAL_MORE_RESPONSE";

export const REQUEST_COVID_TRIALS_COUNTRY = "REQUEST_COVID_TRIALS_COUNTRY";
export const RESPONSE_COVID_TRIALS_COUNTRY = "RESPONSE_COVID_TRIALS_COUNTRY";
export const FAILURE_COVID_TRIALS_COUNTRY = "FAILURE_COVID_TRIALS_COUNTRY";

export const REQUEST_COVID_TRIALS_EXPERTS = "REQUEST_COVID_TRIALS_EXPERTS";
export const RESPONSE_COVID_TRIALS_EXPERTS = "RESPONSE_COVID_TRIALS_EXPERTS";
export const FAILURE_COVID_TRIALS_EXPERTS = "FAILURE_COVID_TRIALS_EXPERTS";

export const REQUEST_COVID_TRIALS_INSTITUTE = "REQUEST_COVID_TRIALS_INSTITUTE";
export const RESPONSE_COVID_TRIALS_INSTITUTE = "RESPONSE_COVID_TRIALS_INSTITUTE";
export const FAILURE_COVID_TRIALS_INSTITUTE = "FAILURE_COVID_TRIALS_INSTITUTE";

export const COVID_NETWORK_RESPONSE = "COVID_NETWORK_RESPONSE";
export const COVID_NETWORK_FAILURE = "COVID_NETWORK_FAILURE";
export const COVID_NETWORK_REQUEST = "COVID_NETWORK_REQUEST";
export const COVID_NETWORK_SELECT_EXPERTS = "COVID_NETWORK_SELECT_EXPERTS";
export const COVID_NETWORK_FILTER_UPDATE = "COVID_NETWORK_FILTER_UPDATE";
export const COVID_NETWORK_RESULT_STATE_UPDATE = "COVID_NETWORK_RESULT_STATE_UPDATE";

export const REQUEST_COVID_MAIN_ORGS_SEARCH = "REQUEST_COVID_MAIN_ORGS_SEARCH";
export const RESPONSE_COVID_MAIN_ORGS_SEARCH = "RESPONSE_COVID_MAIN_ORGS_SEARCH";
export const FAILURE_COVID_MAIN_ORGS_SEARCH = "FAILURE_COVID_MAIN_ORGS_SEARCH";
export const UPDATE_COVID_MAIN_ORGS_SEARCH_FILTER = "UPDATE_COVID_MAIN_ORGS_SEARCH_FILTER";
export const COVID_ORGS_PROFESSIONALS_UPDATE_FILTER = "COVID_ORGS_PROFESSIONALS_UPDATE_FILTER";
export const TOGGLE_COVID_ORGS_SAVE_MODE = "TOGGLE_COVID_ORGS_SAVE_MODE";
export const UPDATE_COVID_ORGS_SAVE_LIST_ITEMS = "UPDATE_COVID_ORGS_SAVE_LIST_ITEMS";
export const UPDATE_COVID_ORGS_SAVE_LIST_TYPE = "UPDATE_COVID_ORGS_SAVE_LIST_TYPE";

//new born experts
export const REQUEST_NEWBORN_MAIN_EXPERTS_SEARCH = "REQUEST_NEWBORN_MAIN_EXPERTS_SEARCH";
export const RESPONSE_NEWBORN_MAIN_EXPERTS_SEARCH = "RESPONSE_NEWBORN_MAIN_EXPERTS_SEARCH";
export const FAILURE_NEWBORN_MAIN_EXPERTS_SEARCH = 'FAILURE_NEWBORN_MAIN_EXPERTS_SEARCH';
export const UPDATE_NEWBORN_MAIN_EXPERTS_SEARCH_FILTER = "UPDATE_NEWBORN_MAIN_EXPERTS_SEARCH_FILTER";
export const TOGGLE_NEWBORN_SAVE_MODE = "TOGGLE_NEWBORN_SAVE_MODE";
export const UPDATE_NEWBORN_SAVE_LIST_ITEMS = "UPDATE_NEWBORN_SAVE_LIST_ITEMS";
export const UPDATE_NEWBORN_SAVE_LIST_TYPE = "UPDATE_NEWBORN_SAVE_LIST_TYPE";
export const NEWBORN_PROFESSIONALS_UPDATE_FILTER = "NEWBORN_PROFESSIONALS_UPDATE_FILTER";

export const NEWBORN_AFFILIATIONS_RESPONSE = "NEWBORN_AFFILIATIONS_RESPONSE";
export const NEWBORN_AFFILIATIONS_FAILURE = "NEWBORN_AFFILIATIONS_FAILURE";
export const NEWBORN_AFFILIATIONS_REQUEST = "NEWBORN_AFFILIATIONS_REQUEST";
export const NEWBORN_AFFILIATIONS_UPDATE = "NEWBORN_AFFILIATIONS_UPDATE";
export const REQUEST_SUMMARY_LOCATION_NEWBORN = "REQUEST_SUMMARY_LOCATION_NEWBORN";
export const RESPONSE_SUMMARY_LOCATION_NEWBORN = "RESPONSE_SUMMARY_LOCATION_NEWBORN";
export const FAILURE_SUMMARY_LOCATION_NEWBORN = "FAILURE_SUMMARY_LOCATION_NEWBORN";
export const NEWBORN_LOCATION_SUMMARY_UPDATE = "NEWBORN_LOCATION_SUMMARY_UPDATE";

//PATENTS
export const REQUEST_MAIN_PATENTS = "REQUEST_MAIN_PATENTS";
export const RESPONSE_MAIN_PATENTS = "RESPONSE_MAIN_PATENTS";
export const FAILURE_MAIN_PATENTS = "FAILURE_MAIN_PATENTS";
export const UPDATE_MAIN_PATENTS = "UPDATE_MAIN_PATENTS";

// EVENTS-NETWORK
export const REQUEST_MAIN_EVENTS_NETWORK = "REQUEST_MAIN_EVENTS_NETWORK";
export const RESPONSE_MAIN_EVENTS_NETWORK = "RESPONSE_MAIN_EVENTS_NETWORK";
export const FAILURE_MAIN_EVENTS_NETWORK = "FAILURE_MAIN_EVENTS_NETWORK";
export const UPDATE_MAIN_EVENTS_NETWORK = "UPDATE_MAIN_EVENTS_NETWORK";
//app landing page api
export const REQUEST_LANDING_HOME = "REQUEST_LANDING_HOME";
export const RESPONSE_LANDING_HOME = "RESPONSE_LANDING_HOME";
export const FAILURE_LANDING_HOME = "FAILURE_LANDING_HOME";

//app user contacts api
export const REQUEST_APP_CONTACTS = "REQUEST_APP_CONTACTS";
export const RESPONSE_APP_CONTACTS = "RESPONSE_APP_CONTACTS";
export const FAILURE_APP_CONTACTS = "FAILURE_APP_CONTACTS";
export const CONTACT_NETWORK_RESPONSE = "CONTACT_NETWORK_RESPONSE";
export const CONTACT_NETWORK_FAILURE = "CONTACT_NETWORK_FAILURE";
export const CONTACT_NETWORK_REQUEST = "CONTACT_NETWORK_REQUEST";
export const CONTACT_NETWORK_SELECT_EXPERTS = "CONTACT_NETWORK_SELECT_EXPERTS";
export const CONTACT_NETWORK_FILTER_UPDATE = "CONTACT_NETWORK_FILTER_UPDATE";
export const CONTACT_NETWORK_RESULT_STATE_UPDATE = "CONTACT_NETWORK_RESULT_STATE_UPDATE";

// app summary
export const APP_SUMMARY_REQUEST = "APP_SUMMARY_REQUEST";
export const APP_SUMMARY_RESPONSE = "APP_SUMMARY_RESPONSE";
export const APP_SUMMARY_FAILURE = "APP_SUMMARY_FAILURE";

// /app experts
export const REQUEST_APP_MAIN_EXPERTS_SEARCH = "REQUEST_APP_MAIN_EXPERTS_SEARCH";
export const RESPONSE_APP_MAIN_EXPERTS_SEARCH = "RESPONSE_APP_MAIN_EXPERTS_SEARCH";
export const FAILURE_APP_MAIN_EXPERTS_SEARCH = "FAILURE_APP_MAIN_EXPERTS_SEARCH";
export const UPDATE_APP_MAIN_EXPERTS_SEARCH_FILTER = "UPDATE_APP_MAIN_EXPERTS_SEARCH_FILTER";
export const APP_PROFESSIONALS_UPDATE_FILTER = "APP_PROFESSIONALS_UPDATE_FILTER";
export const TOGGLE_APP_SAVE_MODE = "TOGGLE_APP_SAVE_MODE";
export const UPDATE_APP_SAVE_LIST_ITEMS = "UPDATE_APP_SAVE_LIST_ITEMS";
export const UPDATE_APP_SAVE_LIST_TYPE = "UPDATE_APP_SAVE_LIST_TYPE";

// new app-experts-table
export const APP_EXPERTS_SEARCH_REQUEST = "APP_EXPERTS_SEARCH_REQUEST";
export const APP_EXPERTS_SEARCH_RESPONSE = "APP_EXPERTS_SEARCH_RESPONSE";
export const APP_EXPERTS_SEARCH_FAILURE = "APP_EXPERTS_SEARCH_FAILURE";
export const APP_EXPERTS_SEARCH_FILTER_UPDATE = "APP_EXPERTS_SEARCH_FILTER_UPDATE";
export const APP_EXPERTS_SEARCH_FULL_RESET = "APP_EXPERTS_SEARCH_FULL_RESET";

// app-institutes
export const APP_AFFILIATIONS_REQUEST = "APP_AFFILIATIONS_REQUEST";
export const APP_AFFILIATIONS_RESPONSE = "APP_AFFILIATIONS_RESPONSE";
export const APP_AFFILIATIONS_FAILURE = "APP_AFFILIATIONS_FAILURE";
export const UPDATE_APP_STAKEHOLDER_FILTERS = "UPDATE_APP_STAKEHOLDER_FILTERS";

// app-locations-summary
export const APP_LOCATIONS_SUMMARY_REQUEST = "APP_LOCATIONS_SUMMARY_REQUEST";
export const APP_LOCATIONS_SUMMARY_RESPONSE = "APP_LOCATIONS_SUMMARY_RESPONSE";
export const APP_LOCATIONS_SUMMARY_FAILURE = "APP_LOCATIONS_SUMMARY_FAILURE";
export const UPDATE_APP_LOCATIONS_FILTERS = "UPDATE_APP_LOCATIONS_FILTERS";

// app trials
export const APP_TRIALS_REQUEST = "APP_TRIALS_REQUEST";
export const APP_TRIALS_RESPONSE = "APP_TRIALS_RESPONSE";
export const APP_TRIALS_FAILURE = "APP_TRIALS_FAILURE";
export const UPDATE_APP_TRIALS_FILTER_STATE = "UPDATE_APP_TRIALS_FILTER_STATE";

// app-congress
export const APP_CONGRESS_REQUEST = "APP_CONGRESS_REQUEST";
export const APP_CONGRESS_RESPONSE = "APP_CONGRESS_RESPONSE";
export const APP_CONGRESS_FAILURE = "APP_CONGRESS_FAILURE";
export const APP_CONGRESS_UPDATE_FILTERS = "APP_CONGRESS_UPDATE_FILTERS";

// app-medical-bodies
export const APP_MEDICAL_BODIES_REQUEST = "APP_MEDICAL_BODIES_REQUEST";
export const APP_MEDICAL_BODIES_RESPONSE = "APP_MEDICAL_BODIES_RESPONSE";
export const APP_MEDICAL_BODIES_FAILURE = "APP_MEDICAL_BODIES_FAILURE";
export const APP_MEDICAL_BODIES_UPDATE_FILTERS = "APP_MEDICAL_BODIES_UPDATE_FILTERS";

// app-collabs-network
export const APP_NETWORK_REQUEST = "APP_NETWORK_REQUEST";
export const APP_NETWORK_RESPONSE = "APP_NETWORK_RESPONSE";
export const APP_NETWORK_FAILURE = "APP_NETWORK_FAILURE";
export const APP_NETWORK_SELECT_EXPERTS = "APP_NETWORK_SELECT_EXPERTS";
export const APP_NETWORK_FILTER_UPDATE = "APP_NETWORK_FILTER_UPDATE";
export const APP_NETWORK_RESULT_STATE_UPDATE = "APP_NETWORK_RESULT_STATE_UPDATE";

// app-social-media
export const APP_SOCIAL_MEDIA_REQUEST = "APP_SOCIAL_MEDIA_REQUEST";
export const APP_SOCIAL_MEDIA_RESPONSE = "APP_SOCIAL_MEDIA_RESPONSE";
export const APP_SOCIAL_MEDIA_FAILURE = "APP_SOCIAL_MEDIA_FAILURE";
export const APP_SOCIAL_MEDIA_UPDATE_FILTERS = "APP_SOCIAL_MEDIA_UPDATE_FILTERS";

// app-other-media
export const APP_OTHER_MEDIA_REQUEST = "APP_OTHER_MEDIA_REQUEST";
export const APP_OTHER_MEDIA_RESPONSE = "APP_OTHER_MEDIA_RESPONSE";
export const APP_OTHER_MEDIA_FAILURE = "APP_OTHER_MEDIA_FAILURE";
export const APP_OTHER_MEDIA_UPDATE_FILTERS = "APP_OTHER_MEDIA_UPDATE_FILTERS";

//app-speciality-centre
export const APP_SPECIALITY_CENTRE_REQUEST = "APP_SPECIALITY_CENTRE_REQUEST";
export const APP_SPECIALITY_CENTRE_RESPONSE = "APP_SPECIALITY_CENTRE_RESPONSE";
export const APP_SPECIALITY_CENTRE_FAILURE = "APP_SPECIALITY_CENTRE_FAILURE";
export const APP_SPECIALITY_CENTRE_UPDATE_FILTERS = "APP_SPECIALITY_CENTRE_UPDATE_FILTERS";

export const REQUEST_ZOGENIX_SPAIN_SEARCH_ELS = "REQUEST_ZOGENIX_SPAIN_SEARCH_ELS";
export const RESPONSE_ZOGENIX_SPAIN_SEARCH_ELS = "RESPONSE_ZOGENIX_SPAIN_SEARCH_ELS";
export const FAILURE_ZOGENIX_SPAIN_SEARCH_ELS = "FAILURE_ZOGENIX_SPAIN_SEARCH_ELS";
export const UPDATE_ZOGENIX_SPAIN_COLUMN_STATES = "UPDATE_ZOGENIX_SPAIN_COLUMN_STATES";

//patents new actions
export const REQUEST_MAIN_PATENT_NEW_SEARCH = "REQUEST_MAIN_PATENT_NEW_SEARCH";
export const RESPONSE_MAIN_PATENT_NEW_SEARCH = "RESPONSE_MAIN_PATENT_NEW_SEARCH";
export const FAILURE_MAIN_PATENT_NEW_SEARCH = "FAILURE_MAIN_PATENT_NEW_SEARCH";
export const RESPONSE_MAIN_PATENT_NEW_SEARCH_TERMS = "RESPONSE_MAIN_PATENT_NEW_SEARCH_TERMS";
export const UPDATE_MAIN_PATENT_NEW_SEARCH_SORT = "UPDATE_MAIN_PATENT_NEW_SEARCH_SORT";

export const REQUEST_PATENTS_MAIN_SEARCH = "REQUEST_PATENTS_MAIN_SEARCH";
export const RESPONSE_PATENTS_MAIN_SEARCH = "RESPONSE_PATENTS_MAIN_SEARCH";
export const FAILURE_PATENTS_MAIN_SEARCH = "FAILURE_PATENTS_MAIN_SEARCH";

export const APP_PUBLICATIONS_REQUEST = "APP_PUBLICATIONS_REQUEST";
export const APP_PUBLICATIONS_RESPONSE = "APP_PUBLICATIONS_RESPONSE";
export const APP_PUBLICATIONS_FAILURE = "APP_PUBLICATIONS_FAILURE";
export const UPDATE_APP_PUBLICATIONS_FILTER_STATE = "UPDATE_APP_PUBLICATIONS_FILTER_STATE";